import logo from "../assets/logo_circle.png"; // Ensure this path is correct
import financepic from "../assets/districtmoney.jpg"; // Financial industry hero image
import hoteldevillemtl from "../assets/hoteldevillemtl_04.jpg"; // Government services hero image
import hotelLobby from "../assets/Hotellobby.jpg"; // Hotels page hero image
import retailStoreHero from "../assets/Small-Retail-Store-Layout-ImpeccaBuild-1-scaled.jpg"; // Retail stores hero image
import educationHero from "../assets/ecoledemusique_vincentdindy_0039_m.jpg"; // Education page hero image

//education
import education from "../assets/whoWeServe/education.jpg"; // Ensure this path is correct
import education3 from "../assets/whoWeServe/education3.jpeg"; // Ensure this path is correct
import education5 from "../assets/whoWeServe/education5.jpg"; // Ensure this path is correct
import education6 from "../assets/whoWeServe/education6.jpg"; // Ensure this path is correct
import collegeLetendreField from "../assets/college-letendre-fieldpic.jpg";
import a6703471EducationPic from "../assets/Carouselcollage/A6703471.jpeg";

//education
import commercial from "../assets/whoWeServe/commercial.jpg"; // Ensure this path is correct
import commercial1 from "../assets/whoWeServe/commercial1.jpg"; // Ensure this path is correct
import commercial2 from "../assets/whoWeServe/commercial2.jpg"; // Ensure this path is correct
import commercial4 from "../assets/whoWeServe/commercial4.jpg"; // Ensure this path is correct
import fedzPic from "../assets/fedz.jpg";

//education
import construction from "../assets/whoWeServe/construction.jpeg"; // Ensure this path is correct
import construction1 from "../assets/whoWeServe/construction1.svg"; // Ensure this path is correct
import construction2 from "../assets/chantier-montreal-construction.jpg";
import construction3 from "../assets/whoWeServe/construction3.jpg"; // Ensure this path is correct
import construction4 from "../assets/whoWeServe/construction4.jpg"; // Ensure this path is correct
import construction6 from "../assets/whoWeServe/construction6.jpg"; // Ensure this path is correct
import construction7 from "../assets/whoWeServe/construction7.jpg"; // Ensure this path is correct
import visionSecurityGck from "../assets/VISION_SECURITY_GCK_EVENT-251.jpg";

// government
import gov from "../assets/whoWeServe/gov.jpg"; // Ensure this path is correct
import gov1 from "../assets/whoWeServe/gov1.webp"; // Ensure this path is correct
import gov2 from "../assets/whoWeServe/gov2.webp"; // Ensure this path is correct
import gov3 from "../assets/whoWeServe/gov3.jpg"; // Ensure this path is correct
import gov4 from "../assets/whoWeServe/gov4.jpg"; // Ensure this path is correct
import gov5 from "../assets/whoWeServe/gov5.jpg"; // Ensure this path is correct
import gov6 from "../assets/whoWeServe/gov6.webp"; // Ensure this path is correct


//education
import finance from "../assets/whoWeServe/finance.jpg"; // Ensure this path is correct
import finance1 from "../assets/whoWeServe/finance1.jpg"; // Ensure this path is correct
import finance2 from "../assets/whoWeServe/finance2.jpg"; // Ensure this path is correct
import finance3 from "../assets/whoWeServe/finance3.jpg"; // Ensure this path is correct
import finance4 from "../assets/whoWeServe/finance4.jpg"; // Ensure this path is correct
import a6703471Pic from "../assets/A6703471.jpeg";
import atmPic from "../assets/pngtree-atm.jpg";
import financeplacemtlPic from "../assets/financeplacemtl.jpg";
import businessSecurity2 from "../assets/industries/business_security2.jpg";


// hotel
import hotel1 from "../assets/whoWeServe/hotel1.jpg"; // Ensure this path is correct
import hotel2 from "../assets/whoWeServe/hotel2.jpg"; // Ensure this path is correct
import hotel3 from "../assets/whoWeServe/hotel3.jpg"; // Ensure this path is correct
import hotel4 from "../assets/whoWeServe/hotel4.jpg"; // Ensure this path is correct
import hotel5 from "../assets/whoWeServe/hotel5.jpg"; // Ensure this path is correct
import hotel6 from "../assets/DSC01642.jpg";
import hotel7 from "../assets/whoWeServe/hotel7.jpg"; // Ensure this path is correct


// retail
import retail1 from "../assets/whoWeServe/retail1.jpg"; // Ensure this path is correct
import retailBlock1 from "../assets/IMG_9527.jpeg";
import retail2 from "../assets/whoWeServe/retail2.jpg"; // Ensure this path is correct
import retailBlock2 from "../assets/industries/loss_prevention.jpeg";
import retail3 from "../assets/whoWeServe/retail3.jpg"; // Ensure this path is correct
import retail4 from "../assets/whoWeServe/retail4.jpg"; // Ensure this path is correct
import retail5 from "../assets/whoWeServe/retail5.jpg"; // Ensure this path is correct
import retail6 from "../assets/whoWeServe/retail6.jpg"; // Ensure this path is correct
import retail7 from "../assets/whoWeServe/retail7.jpg"; // Ensure this path is correct
import retail8 from "../assets/whoWeServe/retail8.jpg"; // Ensure this path is correct
import retailBlock9 from "../assets/IMG_9556.jpeg";

// illegal occupancy intervention
import illegal1 from "../assets/whoWeServe/illegal1.jpg"; // Ensure this path is correct
import illegal2 from "../assets/whoWeServe/dsc01161.jpeg";
import illegal4 from "../assets/whoWeServe/law.jpg";
import illegal5 from "../assets/whoWeServe/abandoned.jpg";
import illegal6 from "../assets/whoWeServe/notes.png";
import illegal7 from "../assets/whoWeServe/illegal7.webp"; // Ensure this path is correct
import photo170Pic from "../assets/Interventioncollage/PHOTO-170.JPG";

// event
import event from "../assets/whoWeServe/event.jpg"; // Ensure this path is correct
import event3 from "../assets/whoWeServe/event3.jpg"; // Ensure this path is correct
import event5 from "../assets/whoWeServe/event5.jpg"; // Ensure this path is correct
import event6 from "../assets/whoWeServe/event6.jpg"; // Ensure this path is correct
import eventNewBlock1 from "../assets/Carouselcollage/VISION_SECURITY_GCK_EVENT-131.jpg";
import eventNewBlock2 from "../assets/Carouselcollage/DSC00918.JPG";
import eventNewBlock3 from "../assets/DSC01625.jpg";
import eventNewBlock5 from "../assets/DSC03204.jpg";
import eventNewBlock7 from "../assets/Carouselcollage/DSC02437.jpg";
import eventNewBlock8 from "../assets/DSC01622.jpg";
import eventNewBlock9 from "../assets/Carouselcollage/P1606374.jpeg";
import luxuryWindsorHero from "../assets/luxurywindsor.jpg";

// warehouse
import ware from "../assets/whoWeServe/DSC03060.jpg";
import ware1 from "../assets/warehouse12.jpeg";
import ware3 from "../assets/DSC01642.jpg";
import ware4 from "../assets/whoWeServe/ware4.webp"; // Ensure this path is correct
import ware5 from "../assets/whoWeServe/ware5.jpg"; // Ensure this path is correct
import ware6 from "../assets/whoWeServe/ware6.jpg"; // Ensure this path is correct
import ware7 from "../assets/whoWeServe/ware7.jpg"; // Ensure this path is correct

export const whoWeServeData = {
  "education": {
    slug: "education",
    hero: {
      bgImage: education,
      imagePosition: "center",
      bgSize: "cover",
      kicker: "Campus Security • Professional Protection",
      title: "Campus Security Services | Educational Institution Guards",
      subtitle: "Real help, real protection — one institution, one campus, one community at a time.",
      dateISO: "2025-10-13",
      readTimeMin: 7,
      tags: ["Education", "Campus Security", "University Security"],
      author: {
        name: "Vision Sécurité Team",
        avatar: logo, // Correct path to public folder
      },
    },
    lead: {
      eyebrow: "Campus Security Services in Québec & Ontario",
      title: "Protecting Educational Institutions in Québec & Ontario",
      accent: "protecting",
      copy:
        "Vision delivers professional campus security services for universities, colleges, K-12 schools, and CEGEPs throughout Montreal, Laval, and the Greater Québec Area. Our licensed BSP security guards provide 24/7 protection, emergency response, and tailored solutions for each educational institution.",
    },
    blocks: [
      {
        quote:
        "Our licensed security professionals provide round-the-clock protection for large university campuses throughout Québec, including downtown Montreal and surrounding areas. We work seamlessly with existing campus security teams and law enforcement to enhance threat deterrence, emergency response capabilities, and overall campus safety without disrupting the academic atmosphere. Whether monitoring residence halls during late-night study sessions or managing access control during major campus events, our guards understand the unique rhythms and requirements of university life.",
        image: educationHero, // Correct path to public folder
        imageAlt: "Maximus Trinchini",
      },
      {
        quote:
        "From elementary schools in Laval to high schools on the South Shore, Vision Sécurité understands the delicate balance required in educational security. Our bilingual security guards are specifically trained in de-escalation techniques and maintain a welcoming presence that supports rather than intimidates the learning environment. We recognize that schools must remain open, nurturing spaces while providing the protection students and educators deserve.",
        image: collegeLetendreField, // Correct path to public folder
        imageAlt: "Christophe Lavoie",
        flip: true,
      },
      {
        quote:
        "Québec's unique CEGEP system requires security professionals who understand the specific needs of post-secondary technical education. Our guards provide comprehensive protection for these institutions, managing everything from workshop security where expensive equipment is housed to coordinating access for evening continuing education programs. The collaborative nature of these institutions demands security professionals who can adapt their approach to support both academic freedom and practical safety requirements.",
        image: education3, // Correct path to public folder
        imageAlt: "CEGEP & Technical Institute Protection",
      },
      {
        title: "Specialized Educational Security Services",
        accent: "university",
        copy:
        "Campus security extends far beyond traditional guard services. Vision provides integrated access control and visitor management through computerized registration systems that track everyone entering campus facilities. Our security professionals are trained to verify student, staff, and faculty identification while coordinating after-hours access for clubs, activities, and special events. We maintain secure perimeter monitoring that adapts to the changing needs of each academic season, from orientation week through finals and graduation ceremonies.Emergency response and crisis management form the cornerstone of our educational security approach. Our guards provide immediate incident response with comprehensive documentation, coordinate seamlessly with Montreal police, Sûreté du Québec, and local emergency services, and are trained in lockdown procedures and evacuation assistance. Every member of our team holds current first aid certification and can provide medical emergency response while professional help arrives.Campus patrol and monitoring services encompass the full scope of educational facilities. Our security professionals conduct regular foot and vehicle patrols across campus grounds, maintain parking lot and residence hall security during all hours, monitor library and study areas to ensure safe learning environments, and provide coverage for athletic facilities and gymnasiums during events and regular operations.",
        image: a6703471EducationPic,
        imageAlt: "University Campus Security",
        flip: true,
      },
      {
        eyebrow: "Security Services",
        title: "Why Québec Educational Institutions Trust Vision",
        accent: "school",
        copy:
          "Vision understands the delicate balance needed in K-12 school security. Our bilingual guards are trained in de-escalation techniques and maintain a welcoming presence, ensuring a safe environment without disrupting the learning experience.",
        points: [
          "Bilingual security staff trained in de-escalation",
          "Proactive safety measures during school events",
          "24/7 protection for school grounds and facilities",
        ],
        image: education5,
        imageAlt: "School Security Guards",

      },
      {
        eyebrow: "Montreal & Québec Coverage Areas",
        title: "Rapid Response for Any Situation",
        accent: "response",
        copy:
        "Vision serves educational institutions throughout Montreal Island, including downtown campuses, West Island schools, and East End institutions. Our Laval coverage encompasses universities, colleges, and technical schools throughout the region. On the South Shore, we protect educational facilities in Longueuil, Brossard, Chambly, and surrounding communities, while our North Shore services extend to Terrebonne, Repentigny, and nearby areas. We also provide services to major institutions in the Québec City region upon request and serve universities and colleges in the Ottawa-Gatineau area of Eastern Ontario.",
        image: education6,
        imageAlt: "Emergency Response",
      },
     
    ],
    footerCta: {
      title: "Ready to Enhance Your Campus Security?",
      accent: "enhance",
      copy:
        "Contact Vision today to schedule a complimentary campus security assessment and receive a tailored protection plan for your educational institution.",
      label: "Get Started",
      href: "/contact",
    },
  },


   "commercial-properties": {
    slug: "commercial-properties",
    hero: {
      bgImage: commercial,
      imagePosition: "center",
      bgSize: "cover",
      kicker: "Commercial Security • Professional Protection",
      title: "Commercial Security Services Montreal | Commercial Institution Guards | Vision Sécurité",
      subtitle: "Real help, real protection — one institution, one Commercial property, one community at a time.",
      dateISO: "2025-10-13",
      readTimeMin: 7,
      tags: ["Commercial", "Commercial Security", "property Security"],
      author: {
        name: "Vision Sécurité Team",
        avatar: logo, 
      },
    },
    lead: {
      eyebrow: "Campus Security Services in Montreal & Québec",
      title: "Protecting Businesse's all over Québec & Ontario",
      accent: "protecting",
      copy:
        "Vision Security delivers professional tailored security solutions for your business. Our licensed BSP security guards provide 24/7 protection, emergency response, and tailored solutions for each new client.",
    },
    blocks: [
      {
        quote:
        "At Vision, we believe commercial property security is about more than a guard at the entrance—it’s about creating a safe, professional, and welcoming environment for everyone who enters your building. From greeting guests and assisting tenants to monitoring cameras and patrolling perimeters, our agents act as an extension of your property management team. Our approach reduces risks, limits liabilities, and ensures that your tenants, staff, and visitors always feel protected.",
        image: commercial1, // Correct path to public folder
        imageAlt: "Maximus Trinchini",
      },
      {
        eyebrow: "Security Services",
        title: "Security as a Smart Investment for Property Owners",
        accent: "Security",
        copy:
        "Commercial property management is evolving—and with it, the demand for value-added security services. At Vision, we go further than traditional guarding by offering:",
        points: [
          "Infiltration testing and vulnerability assessments",
          "Professional secret shoppers for compliance and customer service reviews",
          "Security guards trained in first aid and emergency response",
          "Scenario-based training to prepare for real-world emergencies",

        ],
        image: commercial2,
        imageAlt: "Security Guards",

      },
      {
        quote:
        "Our strength lies in our ability to coordinate with local public safety organizations and integrate multiple layers of protection. From police and fire departments to municipal emergency services, we work hand in hand with these networks to ensure your property is prepared for any scenario. With Vision, you gain a true security partner that puts preparation and prevention first.",
        image: fedzPic, // Correct path to public folder
        imageAlt: "Kevin Wilson",
      },
      {
        title: "The Vision Advantage: Raising the Standard in Commercial Security",
        accent: "The Vision Sécurité",
        copy:"What separates us from other security providers is our commitment to excellence and innovation. Our guards receive specialized in-house training in areas like intervention, de-escalation, and professional etiquette, ensuring they bring both authority and professionalism to your property. Combined with cutting-edge monitoring technology and flexible deployment models, we deliver a level of service that not only meets today’s needs but also adapts to tomorrow’s challenges. With Vision Sécurité, you can count on peace of mind, reduced liability, and a stronger reputation for safety and professionalism across all your commercial properties.",
        image   : commercial4,
        imageAlt: "University Campus Security",
        flip: true,
      },
    ],
    footerCta: {
      title: "Ready to Enhance Your Commercial Property Security?",
      accent: "enhance",
      copy:
        "Contact Vision Sécurité today to schedule a complimentary campus security assessment and receive a tailored protection plan for your commercial institution.",
      label: "Get Started",
      href: "/contact",
    },
  },



   "construction-sites": {
    slug: "construction-sites",
    hero: {
  bgImage: construction, // import your construction image asset
  imagePosition: "center",
  bgSize: "cover",
  kicker: "Construction Security • Theft Prevention",
  title: "Construction Site Security | Theft Prevention & Equipment Protection",
  subtitle: "24/7 licensed BSP guards for after-hours protection—deter theft, secure equipment, and keep projects on schedule across Montreal & Québec.",
  dateISO: "2025-10-14",
  readTimeMin: 7,
  tags: ["Construction", "Theft Prevention", "Equipment Security", "Québec"],
  author: {
    name: "Vision Sécurité Team",
    avatar: logo,
  },
},
    lead: {
  eyebrow: "Construction Site Security in Ontario & Québec",
  title: "Protecting Construction Projects Across Ontario & Québec",
  accent: "protecting",
  copy:
    "Vision provides professional construction site security services designed to prevent theft, vandalism, and unauthorized access. Our licensed BSP guards safeguard equipment, materials, and workers 24/7—ensuring your project stays secure, on schedule, and compliant throughout every phase of construction.",
},

    blocks: [
      {
        title: "Professional Construction Site Security Services in Montreal & Québec",
        accent: "Professional Construction",
        copy: "Construction sites across Montreal, Toronto, Ottawa and the Greater Québec Area face escalating threats from theft, vandalism, and unauthorized access. With equipment theft losses in Canada reaching millions annually and recovery rates below 25%, construction companies need specialized security solutions that protect valuable assets while maintaining project timelines. Vision delivers comprehensive construction site security services designed to safeguard your equipment, materials, and personnel throughout every phase of your project.",
        image   : construction1,
        imageAlt: "University Campus Security",
      },
      {
        title: "Understanding Construction Site Security Challenges in Québec",
        accent: "Understanding Construction",
        copy: "The construction industry in Québec faces unique security vulnerabilities that require targeted protection strategies. Recent reports indicate a sharp rise in construction site theft incidents across the Montreal region, with thieves targeting high-value portable equipment, precious metals, building materials, and heavy machinery during evening hours and weekends. These security breaches result in significant financial losses, project delays, insurance claims, and potential safety hazards that can derail construction schedules and budgets. Construction sites present attractive targets for criminals due to their temporary nature, valuable equipment concentrations, and often limited security measures. The average construction site experiences multiple security incidents annually, with theft values frequently exceeding tens of thousands of dollars per incident. Beyond direct financial losses, construction site security breaches create cascading effects including work stoppages, equipment replacement delays, increased insurance premiums, and potential safety risks for returning workers.",
        image   : construction2,
        imageAlt: "University Campus Security",
        flip: true,
      },
      {
        title: "24/7 On-Site Security Guards",
        accent: "24/7 On-Site",
        copy: "Vision Sécurité provides experienced BSP & ASP licensed security professionals who understand the unique requirements of construction environments. Our guards maintain constant vigilance during high-risk evening and weekend hours when most construction theft occurs. They conduct regular perimeter patrols, monitor access points, and provide immediate response to security incidents. Our construction site security guards are trained in both security protocols and basic construction safety requirements, ensuring they can operate effectively within active work environments while maintaining the highest safety standards.",
        image   : construction3,
        imageAlt: "University Campus Security",
      },
      {
        title: "Mobile Patrol Services",
        accent: "Mobile",
        copy:
        "Our mobile patrol units provide cost-effective security coverage for large construction sites and multiple project locations throughout the Montreal area. These highly visible security vehicles follow randomized patrol schedules that keep potential thieves uncertain about security presence timing. Mobile patrols can cover extensive construction areas efficiently while providing rapid response capabilities to security alerts from other monitoring systems or site personnel.",
        image: construction4,
        imageAlt: "University Campus Security",
        flip: true,
      },
       {
        title: "Access Control & Visitor Management",
        accent: "Access",
        copy:
        "Effective construction site security begins with controlling who enters your property. Vision Sécurité implements comprehensive access control systems that verify worker credentials, manage subcontractor access, and maintain detailed visitor logs. Our security professionals ensure only authorized personnel enter construction areas during both working hours and after-hours periods. This systematic approach prevents unauthorized access while maintaining the legitimate workflow requirements of active construction projects.",
        image: visionSecurityGck,
        imageAlt: "University Campus Security",
      },
      {
        eyebrow: "Always protecting what you neeed",
        title: "Specialized Equipment Protection Services",
        accent: "Specialized",
        copy:
        "Construction equipment represents massive capital investments that require specialized protection strategies. Vision Sécurité understands the specific vulnerabilities of construction machinery and implements targeted security measures to protect these valuable assets. Our equipment protection services include secured storage area monitoring, equipment immobilization verification, and specialized surveillance of high-value machinery locations. Heavy equipment theft often involves organized criminal networks that specifically target construction sites with valuable machinery. Our security professionals are trained to recognize suspicious activities associated with equipment theft attempts, including unauthorized vehicle access, equipment tampering, and coordinated surveillance of construction sites. Early detection and immediate response can prevent equipment theft attempts from succeeding and protect your significant machinery investments. Portable tools and specialized equipment require different protection approaches due to their mobility and high resale value. Vision Sécurité implements secure storage verification protocols, tool inventory monitoring, and end-of-shift security checks that ensure valuable portable equipment remains protected overnight and during non-working periods. Our guards work closely with construction supervisors to maintain equipment accountability while providing flexible security coverage that adapts to changing project needs.",
        image: construction6,
        imageAlt: "Emergency Response",
      },
      {
        title: "After-Hours Security & Perimeter Protection",
        accent: "patrol",
        copy:
        "Construction sites become particularly vulnerable during after-hours periods when work activity ceases and security attention often decreases. Vision Sécurité provides comprehensive after-hours security coverage that maintains protection during these high-risk periods. Our security professionals monitor perimeter areas, conduct building material inspections, and ensure construction site integrity throughout evening and weekend periods when theft activity typically peaks. Perimeter security forms the foundation of effective construction site protection. Our security guards maintain secure fencing integrity, monitor access gates, and ensure proper lighting systems remain functional throughout protection periods. Visible security presence along construction site perimeters serves as a powerful deterrent to potential thieves while providing early warning systems for any unauthorized access attempts.",
        image: construction7,
        imageAlt: "Campus Patrol Services",
        
        flip: true,
      },
    ],
    footerCta: {
      title: "Ready to Enhance Your Campus Security?",
      accent: "enhance",
      copy:
        "Contact Vision Sécurité today to schedule a complimentary campus security assessment and receive a tailored protection plan for your educational institution.",
      label: "Get Started",
      href: "/contact",
    },
  },



   "financial-industry": {
    slug: "financial-industry",
    hero: {
      bgImage: financepic,
      imagePosition: "center",
      bgSize: "cover",
      kicker: "Campus Security • Professional Protection",
      title: "Financial Sector Security Services | Ontario & Québec |",
      subtitle: "Real help, real protection — one institution, one campus, one community at a time.",
      dateISO: "2025-10-13",
      readTimeMin: 7,
      tags: ["Banks", "Financial Buildings", "Data Centers"],
      author: {
        name: "Vision Sécurité Team",
        avatar: "/assets/vision-foundation/avatar.png", // Correct path to public folder
      },
    },
    lead: {
      eyebrow: "Financial Security Guarding Services",
      title: "Protecting Financial Institutions in Montreal, Toronto & Ottawa",
      accent: "protecting",
      copy:
        "Vision delivers professional security services for banks, financial buildings & institutions throughout Montreal, Ottawa, Toronto and the Greater Québec Area. Our licensed BSP security guards provide 24/7 protection, emergency response, and tailored solutions for each client's needs.",
    },
    blocks: [
      {
        title: "Professional Financial Institution Security Services in Montreal & Québec",
        accent: "Professional Financial",
        copy:
        "Financial institutions across Québec face an increasingly complex threat environment where physical security, cyber risks, and regulatory compliance converge daily. Banks, credit unions, investment firms, insurance companies, and fintech organizations require specialized security solutions that protect assets, personnel, and sensitive information while maintaining the professional, welcoming atmosphere essential to customer relationships. Vision Sécurité delivers comprehensive financial institution security services throughout Montreal, Laval, and the Greater Québec Area, with extended coverage to Québec City and Eastern Ontario markets. The financial services industry has experienced significant security challenges in recent years, with incidents ranging from sophisticated fraud schemes to physical threats against branch locations. The Desjardins data breach affecting 4.2 million members highlighted the critical importance of comprehensive security measures that address both digital and physical vulnerabilities. Financial institutions must balance accessibility with protection, ensuring customers feel secure while maintaining the operational efficiency required in competitive banking markets.",
        image: finance,
        imageAlt: "Campus Patrol Services",
        },
          {
        title: "Branch & Retail Banking Security Solutions",
        accent: "Branch & Retail",
        copy:"Branch locations represent the public face of financial institutions, requiring security professionals who understand customer service excellence alongside threat detection and response capabilities. Vision Sécurité provides experienced BSP-licensed security guards who maintain welcoming environments while monitoring for suspicious activities, managing access control, and ensuring smooth daily operations. Our guards understand the unique rhythms of branch banking, from morning opening procedures through evening cash reconciliation processes. Customer-facing security in financial branches requires subtle professionalism that reassures without intimidating. Our security professionals are trained in conflict de-escalation techniques, customer service protocols, and emergency response procedures specific to banking environments. They work seamlessly with branch staff to manage visitor flow, assist with security system operations, and provide immediate response to security alerts or unusual incidents. During high-traffic periods like payroll processing or holiday banking rushes, our guards adapt their positioning and procedures to maintain security without disrupting customer service. Cash handling and vault security operations demand rigorous protocols and constant vigilance. Vision Sécurité guards are trained in dual-control procedures, time-lock protocols, and secure transportation coordination. They monitor cash delivery processes, verify armored car procedures, and maintain sight lines during high-risk cash handling operations. Our documentation standards ensure proper incident reporting for insurance, regulatory compliance, and law enforcement coordination when required.",
        image: finance1,
        imageAlt: "Campus Patrol Services",
        flip: true,
        },
      {
        title: "ATM Security & Electronic Banking Protection",
        accent: "ATM Security",
        copy:
        "Automated banking machines present unique security vulnerabilities that require specialized monitoring and protection strategies. Vision Sécurité provides comprehensive ATM security services including perimeter monitoring, skimming device detection, and immediate response to tampering alerts. Our guards conduct regular inspection protocols that verify machine integrity, lighting functionality, and surveillance system operation while maintaining discrete observation of ATM usage patterns. After-hours ATM security becomes particularly critical when machines operate without branch supervision. Our mobile patrol units provide randomized monitoring schedules that keep potential criminals uncertain about security presence timing. Guards are trained to recognize signs of ATM tampering, card skimming devices, and other fraud indicators that can compromise customer security and institutional liability. Immediate reporting protocols ensure rapid response to security breaches and coordination with law enforcement when criminal activity is suspected. Electronic banking vestibules require careful balance between accessibility and security. Vision Sécurité guards manage after-hours access protocols, monitor customer safety during evening banking activities, and ensure proper lighting and surveillance system functionality. They provide assistance to customers experiencing difficulties while maintaining vigilance for suspicious activities or security threats that could compromise customer safety or machine integrity.",
        image: atmPic,
        imageAlt: "Campus Patrol Services",
        },
      {
        eyebrow: "Comprehensive Protection for All Corporate Levels",
        title: "Corporate Offices & Administrative Facility Security",
        accent: "Corporate Offices",
        copy:
        "Financial institution headquarters and administrative offices house sensitive information, executive personnel, and critical infrastructure that require sophisticated security measures. Vision Sécurité provides comprehensive corporate security services including access control management, visitor verification, and executive protection services when required. Our guards understand corporate environments and maintain professional standards that align with institutional culture and brand reputation requirements. Access control in financial corporate environments involves multiple security zones with varying clearance requirements. Our security professionals manage multi-level authentication systems, coordinate visitor badges and escorts, and maintain detailed logs of personnel movement throughout secure facilities. They work closely with human resources and facilities management to ensure security protocols support business operations while maintaining strict compliance with internal security policies and regulatory requirements. Executive protection and VIP security services address the unique risks faced by financial institution leadership. Vision Sécurité provides discrete personal protection, secure transportation coordination, and event security services for executives attending high-profile meetings, conferences, or public appearances. Our executive protection specialists understand the balance between visibility and discretion required in financial industry leadership security.",
        image: finance3,
        imageAlt: "University Campus Security",
        flip: true,
      },
    
      {
        title: "Investment Firms & Insurance Office Security",
        accent: "Investment",
        copy:
        "Investment and insurance offices handle sensitive client information and significant financial assets that require specialized protection approaches. Vision Sécurité understands the unique security requirements of these environments, including document security, client privacy protection, and regulatory compliance obligations. Our guards provide access control, visitor management, and incident response services tailored to the specific needs of financial advisory and insurance operations. Client confidentiality remains paramount in investment and insurance environments. Our security professionals are trained in privacy protocols, confidential document handling, and discrete observation techniques that protect sensitive client interactions while maintaining security vigilance. They understand the importance of creating secure environments where clients feel comfortable discussing personal financial matters without compromising institutional security requirements. Document security and information protection extend beyond digital systems to include physical document handling, secure storage verification, and proper disposal protocols. Vision Sécurité guards monitor secure document storage areas, verify proper filing procedures, and ensure compliance with document retention and destruction policies that meet regulatory requirements and internal audit standards.",
        image: finance4,
        imageAlt: "Emergency Response",
      },
      {
        title: "Fintech & Innovation Hub Security",
        accent: "Fintech",
        copy:
        "Modern financial technology companies require security solutions that protect both traditional assets and cutting-edge digital infrastructure. Vision Sécurité provides specialized security services for fintech offices, innovation labs, and technology development centers that understand the unique challenges of protecting intellectual property, server environments, and collaborative workspaces. Our approach balances open innovation culture with strict security protocols required for financial technology development. Technology infrastructure protection in fintech environments requires understanding of both physical and cyber security integration. Our guards monitor server rooms, development laboratories, and secure communication areas while coordinating with IT security teams to ensure comprehensive protection strategies. They understand the critical importance of maintaining secure environments for financial technology development and testing activities. Research and development security becomes particularly important in fintech environments where proprietary algorithms, customer data models, and financial innovation represent significant competitive advantages. Vision Sécurité provides specialized monitoring of R&D facilities, visitor management for technology demonstrations, and secure meeting facilitation for confidential product development discussions.",
        image: a6703471Pic,
        imageAlt: "Campus Patrol Services",
        
        flip: true,
      },
      {
        title: "Emergency Response & Incident Management",
        accent: "Emergency",
        copy:
        "Financial institutions require immediate, professional response to security incidents ranging from robbery attempts to medical emergencies and system failures. Vision Sécurité security guards receive specialized training in financial institution emergency procedures, including coordination with law enforcement, emergency medical services, and internal crisis management teams. Our response protocols minimize disruption while ensuring proper evidence preservation and regulatory compliance documentation. Robbery response procedures in financial environments require calm, trained professionals who understand both customer safety and evidence preservation requirements. Our guards follow established protocols for silent alarm activation, customer and staff protection, and post-incident security management. They provide detailed incident documentation that supports law enforcement investigations, insurance claims processing, and internal security reviews. Crisis communication management becomes critical during financial institution security incidents. Vision Sécurité guards coordinate with management teams to ensure appropriate internal and external communication protocols while maintaining security perimeters and preserving incident scene integrity. They understand the reputational sensitivities involved in financial institution security incidents and follow communication procedures that protect institutional interests while supporting law enforcement requirements.",
        image: financeplacemtlPic,
        imageAlt: "Campus Patrol Services",
        
      },
        {
        title: "Regulatory Compliance & Industry Standards",
        accent: "Regulatory Compliance",
        copy:
        "Financial institution security must meet stringent regulatory requirements including BSP licensing, privacy legislation compliance, and industry-specific security standards. Vision Sécurité maintains current knowledge of Québec financial industry regulations, federal banking security requirements, and provincial privacy legislation that governs financial institution operations. Our documentation and reporting procedures support regulatory compliance audits and internal security assessments. Privacy protection and confidentiality requirements in financial environments extend beyond customer information to include internal operations, strategic planning, and regulatory compliance activities. Our security professionals understand confidentiality obligations, document handling procedures, and communication protocols that protect sensitive institutional information while maintaining effective security operations. Industry certification and training standards ensure Vision Sécurité security personnel meet the specialized requirements of financial institution environments. Our guards receive ongoing training in financial industry security protocols, emergency response procedures, and regulatory compliance requirements that support institutional audit and certification processes.",
        image: finance1,
        imageAlt: "Campus Patrol Services",
        
        flip: true,
      },
      {
        title: "Technology Integration & Modern Security Solutions",
        accent: "Technology Integration",
        copy:
        "Contemporary financial institution security requires integration between human security professionals and advanced technology systems. Vision Sécurité coordinates with existing access control systems, surveillance networks, and alarm monitoring to provide comprehensive security coverage. Our guards understand modern security technology and can operate integrated systems while providing the human judgment and response capabilities that technology alone cannot deliver. Surveillance system coordination involves understanding camera coverage patterns, blind spot identification, and evidence preservation procedures that support both real-time security monitoring and post-incident investigation requirements. Our guards work with facility management to optimize surveillance effectiveness while maintaining customer privacy and regulatory compliance standards. Access control technology integration includes badge systems, biometric verification, and visitor management platforms that streamline security operations while maintaining strict authorization protocols. Vision Sécurité security professionals adapt to various technology platforms while ensuring backup procedures remain available during system failures or maintenance periods.",
        image: finance2,
        imageAlt: "Campus Patrol Services",
        
      },
       {
        title: "Coverage Areas & Service Deployment",
        accent: "Coverage Areas",
        copy:
        "Vision Sécurité provides financial institution security services throughout the Island of Montreal, including downtown banking districts, suburban branch networks, and corporate headquarters locations. Our Laval coverage encompasses credit unions, community banks, and regional financial service centers throughout the area. South Shore protection extends to Longueuil, Brossard, and surrounding communities where significant financial institution presence requires professional security services. North Shore financial institution security covers Terrebonne, Repentigny, and nearby areas with growing banking and financial services infrastructure. Extended service areas include Québec City region financial institutions and Eastern Ontario locations in Ottawa-Gatineau where Québec-based financial institutions maintain operations requiring bilingual security services and regulatory compliance expertise.",
        image: finance,
        imageAlt: "Campus Patrol Services",
        
        flip: true,
      },
       {
        title: "Performance Metrics & Service Excellence",
        accent: "Performance Metrics",
        copy:
        "Financial institutions working with Vision Sécurité report improved security incident response times, reduced theft and fraud losses, and enhanced customer confidence in branch security. Our average emergency response time for financial institution incidents is under three minutes, with immediate coordination with law enforcement and emergency services when required. Customer satisfaction surveys consistently rate our security professionals highly for professionalism, helpfulness, and discrete security presence. Security incident prevention remains our primary focus, with proactive monitoring and threat assessment procedures that identify and address potential security risks before they escalate into actual incidents. Our guards maintain detailed activity logs and regular reporting that enables financial institutions to track security performance metrics and identify areas for continuous improvement.",
        image: finance3,
        imageAlt: "Campus Patrol Services",
        
      },
         {
        title: "Getting Started with Financial Institution Security",
        accent: "Getting Started",
        copy:
        "Every financial institution presents unique security challenges based on location, customer demographics, operational procedures, and regulatory requirements. Vision Sécurité begins each engagement with comprehensive security assessments that evaluate current protection measures, identify potential vulnerabilities, and develop customized security protocols. Our assessment process includes risk analysis, regulatory compliance review, emergency response planning, and integration with existing security infrastructure.",
        image: businessSecurity2,
        imageAlt: "Campus Patrol Services",
        
        flip: true,
      },
    ],
    footerCta: {
      title: "Ready to Enhance Your Campus Security?",
      accent: "enhance",
      copy:
        "Contact Vision Sécurité today to schedule a complimentary campus security assessment and receive a tailored protection plan for your educational institution.",
      label: "Get Started",
      href: "/contact",
    },
  },




   "government-services": {
  slug: "government-services",
  hero: {
    bgImage: gov2,
    imagePosition: "center",
    bgSize: "cover",
    kicker: "Government Security • Public Sector Protection",
    title: "Government Security Services Montreal | Public Sector Protection | Vision Sécurité",
    subtitle: "Professional government and public sector security services in Montreal & Québec. Licensed BSP guards for municipal, provincial, and federal facilities. Compliance-focused protection.",
    dateISO: "2025-10-13",
    readTimeMin: 7,
    tags: ["Government Security", "Public Sector", "Québec"],
    author: {
      name: "Vision Sécurité Team",
      avatar: "/assets/vision-foundation/avatar.png",
    },
  },

  lead: {
    eyebrow: "Government Security Services in Montreal & Québec",
    title: "Protecting Government Facilities Across Québec",
    accent: "Government",
    copy:
      "Licensed BSP professionals for municipal, provincial, and federal environments—balancing accessibility, safety, and compliance across Montreal, Québec City, and beyond.",
  },

  blocks: [
    {
      title: "Professional Government & Public Sector Security Services in Montreal & Québec",
      accent: "Government & Public Sector",
      copy:
        "Government facilities across Montreal, Québec City, and the broader Québec region face complex security challenges that require specialized expertise, regulatory compliance, and unwavering professionalism. From municipal offices and courthouses to federal buildings and provincial administrative centers, public sector institutions must balance accessibility with protection while maintaining the trust and confidence of the citizens they serve. Vision Sécurité delivers comprehensive government security services throughout Québec, providing licensed BSP professionals who understand the unique requirements of public sector environments.",
      image: hoteldevillemtl,
      imageAlt: "Government & public sector security overview",
    },
    {
      title: "Comprehensive Government Security Programs",
      accent: "Programs",
      copy:
        "Government security extends far beyond traditional guard services, encompassing threat assessment, regulatory compliance, emergency response coordination, and public relations management in high-stakes environments. The evolving security landscape requires adaptable solutions that address everything from routine access control to crisis management during civil unrest or emergency situations. Vision Sécurité partners with government institutions to develop comprehensive security programs that protect personnel, visitors, and sensitive information while supporting democratic accessibility and public service delivery.",
      image: gov3,
      imageAlt: "Integrated government security program planning",
      flip: true,
    },

    /* ---------------- Municipal Government Security Solutions ---------------- */
    {
      title: "Municipal Government Security Solutions",
      accent: "Municipal",
      copy:
        "Municipal buildings serve as the front line of government services, welcoming thousands of citizens daily for essential services ranging from permit applications to public meetings. Vision Sécurité provides specialized municipal security services that balance welcoming accessibility with necessary protection measures. Our security professionals understand the unique dynamics of municipal environments, where public servants interact with citizens experiencing various levels of stress, frustration, or urgency regarding government services.",
      image: gov4,
      imageAlt: "Municipal security services for city facilities",
    },
    {
      title: "City Halls, Service Centers & Administrative Offices",
      accent: "City Halls",
      copy:
        "City halls, municipal service centers, and administrative offices require security approaches that maintain professional atmospheres while managing diverse visitor populations. Our guards are trained in conflict de-escalation techniques, customer service excellence, and emergency response procedures specific to municipal environments. They work closely with municipal staff to ensure smooth daily operations while providing discrete security monitoring that maintains public confidence in government accessibility.",
      image: gov5,
      imageAlt: "Security presence at city halls and service centers",
      flip: true,
    },
    {
      title: "Council Meetings & Public Hearings Security",
      accent: "Public Hearings",
      copy:
        "Municipal council meetings and public hearings present unique security challenges that require careful crowd management and threat assessment capabilities. Vision Sécurité security professionals provide comprehensive meeting security services including pre-event risk assessments, crowd control management, and emergency evacuation procedures. Our guards understand the importance of maintaining democratic processes while ensuring participant safety during potentially contentious public meetings.",
      image: gov6,
      imageAlt: "Council meeting security and crowd management",
    },

    /* ---------------- Provincial Government Facility Protection ---------------- */
    {
      title: "Provincial Government Facility Protection",
      accent: "Provincial",
      copy:
        "Provincial government facilities house sensitive administrative functions, policy development activities, and executive offices that require sophisticated security measures. Vision Sécurité provides comprehensive provincial facility security services including access control management, visitor verification systems, and executive protection when required. Our security professionals understand the complex security requirements of provincial government operations while maintaining the professional standards expected in high-level government environments.",
      image: gov4,
      imageAlt: "Provincial facility protection services",
      flip: true,
    },
    {
      title: "Legislative Buildings & Administrative Centers",
      accent: "Legislative",
      copy:
        "Legislative buildings and provincial administrative centers require multi-layered security approaches that accommodate public access while protecting sensitive government functions. Our guards manage security checkpoints, coordinate visitor escorts, and maintain detailed access logs that support both security objectives and government transparency requirements. They work closely with provincial security coordinators to ensure comprehensive protection strategies that align with government security policies and procedures.",
      image: gov1,
      imageAlt: "Security at legislative and administrative centers",
    },
    {
      title: "Executive Protection for Provincial Officials",
      accent: "Executive",
      copy:
        "Executive protection services for provincial officials require discrete, professional security personnel who understand political environments and protocol requirements. Vision Sécurité provides specialized executive protection services including secure transportation coordination, event security management, and threat assessment capabilities. Our executive protection specialists maintain low profiles while providing comprehensive security coverage for government officials during public appearances and official functions.",
      image: gov,
      imageAlt: "Executive protection services",
      flip: true,
    },

    /* ---------------- Federal Building & Courthouse Security ---------------- */
    {
      title: "Federal Building & Courthouse Security",
      accent: "Federal & Courts",
      copy:
        "Federal facilities and courthouses represent high-value targets that require stringent security measures and strict regulatory compliance. Vision Sécurité provides specialized federal facility security services that meet or exceed federal security standards while maintaining operational efficiency. Our security professionals understand federal security protocols, clearance requirements, and coordination procedures with federal law enforcement agencies.",
      image: gov3,
      imageAlt: "Security for federal buildings and courthouses",
    },
    {
      title: "Courthouse Security Operations",
      accent: "Courthouse",
      copy:
        "Courthouse security demands specialized training in judicial security protocols, evidence handling procedures, and courtroom management techniques. Our guards provide comprehensive courthouse security services including defendant transport coordination, jury protection, and judicial officer security. They understand the sensitive nature of judicial proceedings while maintaining security vigilance that protects all courtroom participants without disrupting legal processes.",
      image: gov6,
      imageAlt: "Judicial and courtroom security procedures",
      flip: true,
    },
    {
      title: "Federal Access Control & Clearances",
      accent: "Clearances",
      copy:
        "Federal building access control requires sophisticated verification procedures and multi-level security clearance management. Vision Sécurité security professionals manage complex access control systems, coordinate visitor background checks, and maintain detailed security logs that support federal audit requirements. They work closely with federal security coordinators to ensure comprehensive protection strategies that meet federal security standards while supporting government operations.",
      image: gov5,
      imageAlt: "Federal access control and clearance management",
    },

    /* ---------------- Emergency Services & Crisis Management ---------------- */
    {
      title: "Emergency Services Coordination & Crisis Management",
      accent: "Crisis Management",
      copy:
        "Government facilities must maintain operational capability during emergencies while providing secure environments for emergency response coordination. Vision Sécurité provides specialized emergency security services that support government continuity operations during natural disasters, civil unrest, or other crisis situations. Our security professionals are trained in emergency coordination protocols and maintain communication links with multiple law enforcement and emergency service agencies.",
      image: gov6,
      imageAlt: "Emergency coordination in government facilities",
      flip: true,
    },
    {
      title: "Crisis Communication Management",
      accent: "Communication",
      copy:
        "Crisis communication management becomes particularly critical during government security incidents where public confidence and media attention create additional complications. Our guards coordinate with government communications teams to ensure appropriate information management while maintaining security perimeters and operational security. They understand the political sensitivities involved in government security incidents and follow communication protocols that protect institutional interests while supporting emergency response requirements.",
      image: gov2,
      imageAlt: "Crisis communication procedures",
    },
    {
      title: "Evacuation Procedures & Emergency Training",
      accent: "Evacuation",
      copy:
        "Evacuation procedures and emergency response coordination in government facilities require detailed planning and regular training updates. Vision Sécurité works with government facility managers to develop comprehensive emergency response plans, conduct regular evacuation drills, and maintain current contact information for all relevant emergency services. Our guards receive specialized training in government emergency procedures and maintain current certifications in emergency response techniques.",
      image: gov3,
      imageAlt: "Evacuation planning and emergency training",
      flip: true,
    },

    /* ---------------- Regulatory Compliance & Standards ---------------- */
    {
      title: "Regulatory Compliance & Security Standards",
      accent: "Compliance",
      copy:
        "Government security operations must comply with multiple regulatory frameworks including federal security standards, provincial regulations, and municipal bylaws. Vision Sécurité maintains current knowledge of government security regulations and provides documentation and reporting services that support regulatory compliance audits. Our security professionals understand the complex regulatory environment governing government security operations and ensure all security activities meet or exceed applicable standards.",
      image: gov6,
      imageAlt: "Regulatory compliance for government security",
    },
    {
      title: "Privacy Protection & Information Security",
      accent: "Privacy",
      copy:
        "Privacy protection and information security requirements in government environments extend beyond physical security to include document handling, visitor management, and communication protocols. Our security professionals are trained in government privacy requirements, confidential document procedures, and secure communication practices that protect sensitive government information while maintaining operational efficiency.",
      image: finance1,
      imageAlt: "Privacy and information security protocols",
      flip: true,
    },
    {
      title: "Security Clearances & Personnel Vetting",
      accent: "Clearances",
      copy:
        "Security clearance management and personnel verification procedures ensure all Vision Sécurité security personnel assigned to government facilities meet applicable clearance requirements. Our guards undergo comprehensive background investigations and maintain current security clearances appropriate for their assigned government facilities. We coordinate with government security officers to ensure proper clearance verification and ongoing compliance monitoring.",
      image: gov,
      imageAlt: "Personnel vetting and clearance management",
    },

    /* ---------------- Technology Integration ---------------- */
    {
      title: "Technology Integration & Modern Government Security",
      accent: "Technology",
      copy:
        "Contemporary government security requires integration between human security professionals and advanced technology systems including biometric access control, surveillance networks, and threat detection systems. Vision Sécurité coordinates with existing government security infrastructure while providing human oversight and response capabilities that technology alone cannot deliver. Our guards understand government technology systems and can operate integrated security platforms while maintaining backup procedures during system failures.",
      image: gov2,
      imageAlt: "Integrated security technology in government",
      flip: true,
    },
    {
      title: "Surveillance Systems & Evidence Handling",
      accent: "Surveillance",
      copy:
        "Surveillance system coordination involves understanding complex camera networks, evidence preservation procedures, and privacy protection requirements that govern government surveillance activities. Our guards work with government IT security teams to optimize surveillance effectiveness while maintaining citizen privacy rights and regulatory compliance standards.",
      image: gov6,
      imageAlt: "Surveillance networks and evidence procedures",
    },
    {
      title: "Threat Assessment & Intelligence Coordination",
      accent: "Threat Intel",
      copy:
        "Threat assessment and intelligence coordination requires understanding government intelligence protocols and coordination procedures with law enforcement agencies. Vision Sécurité security professionals maintain communication links with relevant law enforcement agencies and provide threat reporting services that support government security intelligence requirements.",
      image: gov1,
      imageAlt: "Threat assessment and intelligence coordination",
      flip: true,
    },

    /* ---------------- Public Events & Government Functions ---------------- */
    {
      title: "Public Events & Government Function Security",
      accent: "Public Events",
      copy:
        "Government-sponsored public events require comprehensive security planning that accommodates large crowds while maintaining democratic accessibility. Vision Sécurité provides specialized public event security services including crowd management, VIP protection, and emergency response coordination. Our security professionals understand the unique challenges of securing government events where political sensitivities and public safety requirements intersect.",
      image: gov2,
      imageAlt: "Security for public government events",
    },
    {
      title: "Protest Management & Demonstration Security",
      accent: "Protests",
      copy:
        "Protest management and demonstration security requires trained professionals who understand constitutional rights while maintaining public safety and government facility security. Our guards are trained in crowd psychology, de-escalation techniques, and coordination procedures with law enforcement agencies during civil demonstrations. They maintain neutral positions while ensuring government facility security and protecting the rights of all participants.",
      image: gov,
      imageAlt: "Demonstration and protest security coordination",
      flip: true,
    },
    {
      title: "Ceremonial & Official Function Security",
      accent: "Ceremonial",
      copy:
        "Ceremonial events and official functions require discrete security coverage that maintains dignified atmospheres while providing comprehensive protection. Vision Sécurité provides specialized ceremonial security services including honor guard coordination, VIP escort services, and protocol security management. Our guards understand government protocol requirements while maintaining security vigilance during official ceremonies and functions.",
      image: gov4,
      imageAlt: "Security for ceremonial and official functions",
    },

    /* ---------------- Coverage Areas ---------------- */
    {
      title: "Coverage Areas & Service Deployment",
      accent: "Coverage",
      copy:
        "Vision Sécurité provides government security services throughout Québec including Montreal municipal facilities, provincial government offices in Québec City, and federal facilities across the province. Our coverage extends to regional government centers, courthouse facilities, and administrative offices throughout the Greater Montreal Area, Laval, South Shore, and North Shore regions.",
      image: gov6,
      imageAlt: "Government security coverage across Québec",
      flip: true,
    },
    {
      title: "Extended Service Areas",
      accent: "Extended",
      copy:
        "Extended service areas include Eastern Ontario government facilities in Ottawa-Gatineau where Québec-based government offices require bilingual security services and provincial regulatory compliance. We also provide specialized government security services for international facilities including consulates and diplomatic missions requiring enhanced security protocols.",
      image: gov5,
      imageAlt: "Extended service areas including Ottawa-Gatineau and consulates",
    },

    /* ---------------- Performance & Excellence ---------------- */
    {
      title: "Performance Metrics & Government Security Excellence",
      accent: "Performance",
      copy:
        "Government facilities working with Vision Sécurité report improved security incident response times, enhanced regulatory compliance ratings, and increased public confidence in government facility security. Our average emergency response time for government security incidents is under two minutes, with immediate coordination with appropriate law enforcement and emergency services.",
      image: gov,
      imageAlt: "Government security performance metrics",
      flip: true,
    },
    {
      title: "Security Incident Prevention & Reporting",
      accent: "Prevention",
      copy:
        "Security incident prevention remains our primary focus through proactive threat assessment, comprehensive facility monitoring, and regular security procedure updates. Our guards maintain detailed activity logs and provide regular reporting that enables government security coordinators to track performance metrics and identify areas for continuous improvement.",
      image: gov1,
      imageAlt: "Preventive security and reporting for government sites",
    },

    /* ---------------- Getting Started ---------------- */
    {
      title: "Getting Started with Government Security Services",
      accent: "Getting Started",
      copy:
        "Every government facility presents unique security challenges based on function, public access requirements, security clearance levels, and regulatory compliance obligations. Vision Sécurité begins each government security engagement with comprehensive security assessments that evaluate current protection measures, identify potential vulnerabilities, and develop customized security protocols that meet government standards while supporting operational requirements.",
      image: gov3,
      imageAlt: "Government security assessment and onboarding",
      flip: true,
    },
  ],

  footerCta: {
    title: "Ready to Enhance Your Government Facility Security?",
    accent: "enhance",
    copy:
      "Contact Vision Sécurité today to schedule a complimentary government security assessment and receive a tailored protection plan for your municipal, provincial, or federal facility.",
    label: "Get Started",
    href: "/contact",
  },
}
,


























   "warehouses": {
  slug: "warehouses",
  hero: {
    bgImage: ware6,
    imagePosition: "center",
    bgSize: "cover",
    kicker: "Warehouse Security • Logistics Protection",
    title: "Warehouse Security Services Montreal | Logistics & Industrial Protection | Vision Sécurité",
    subtitle:
      "Professional warehouse and logistics security in Montreal & Québec. BSP guards for distribution centers, cargo protection, and supply chain security. 24/7 coverage.",
    dateISO: "2025-10-13",
    readTimeMin: 7,
    tags: ["Warehouse", "Logistics", "Industrial Security"],
    author: {
      name: "Vision Sécurité Team",
      avatar: "/assets/vision-foundation/avatar.png",
    },
  },

  lead: {
    eyebrow: "Warehouse & Logistics Security in Montreal & Québec",
    title: "Protecting Warehouses and Supply Chains Across Québec",
    accent: "Warehouse",
    copy:
      "Comprehensive security for warehouses, distribution centers, and logistics facilities across Québec—protecting goods, workers, and transportation networks with licensed BSP professionals.",
  },

  blocks: [
    {
      title: "Professional Warehouse & Logistics Security Services in Montreal & Québec",
      accent: "Warehouse & Logistics",
      copy:
        "Montreal's strategic position at the heart of North America's transportation networks makes it a critical logistics hub where billions of dollars in goods move through warehouses, distribution centers, and industrial facilities daily. From the Port of Montreal to major distribution centers throughout the Greater Montreal Area, logistics operations face escalating security challenges including cargo theft, facility break-ins, inventory shrinkage, and supply chain disruptions. Vision Sécurité delivers comprehensive warehouse and logistics security services designed to protect valuable inventory, secure transportation corridors, and maintain operational continuity throughout Québec's vital logistics infrastructure.",
      image: ware1,
      imageAlt: "Warehouse logistics security overview",
    },
    {
      title: "Expanding Logistics and Emerging Security Challenges",
      accent: "Logistics",
      copy:
        "The logistics industry in Québec has experienced significant growth, with Montreal serving as a gateway between North American markets and international trade routes. This expansion has created new security vulnerabilities as criminals increasingly target high-value cargo shipments, distribution facilities, and transportation hubs. Modern warehouse operations require sophisticated security approaches that protect against both external threats and internal risks while supporting the efficient flow of goods that keeps supply chains operating smoothly.",
      image: ware,
      imageAlt: "Growing logistics sector and security challenges",
      flip: true,
    },

    /* ---------------- Distribution & Warehouse Security ---------------- */
    {
      title: "Distribution Center & Warehouse Facility Security",
      accent: "Distribution Centers",
      copy:
        "Large-scale distribution centers and warehouse facilities represent attractive targets for organized theft due to their concentrated high-value inventory and often limited overnight security presence. Vision Sécurité provides comprehensive facility security services that protect warehouse operations through strategic guard placement, comprehensive perimeter monitoring, and coordinated access control systems. Our security professionals understand the unique operational requirements of logistics facilities and adapt their protection strategies to support continuous warehouse operations without disrupting productivity.",
      image: ware3,
      imageAlt: "Distribution center security services",
    },
    {
      title: "Comprehensive Warehouse Protection & Safety Coordination",
      accent: "Warehouse Protection",
      copy:
        "Warehouse security extends beyond simple theft prevention to encompass inventory protection, worker safety coordination, and operational security measures that prevent disruptions to critical supply chain functions. Our guards monitor loading dock activities, verify vendor credentials, and maintain detailed logs of all personnel and vehicle access to secure warehouse areas. They coordinate closely with warehouse managers to ensure security protocols support operational efficiency while providing comprehensive protection against both internal and external security threats.",
      image: ware4,
      imageAlt: "Warehouse patrol and operational security",
      flip: true,
    },
    {
      title: "After-Hours Warehouse Security & Alarm Response",
      accent: "After-Hours",
      copy:
        "After-hours warehouse security becomes particularly critical when facilities contain millions of dollars in inventory with minimal staff presence. Vision Sécurité guards conduct comprehensive facility patrols, monitor alarm systems, and maintain communication with central monitoring stations to ensure immediate response to security alerts. Our security professionals are trained to recognize signs of attempted break-ins, cargo tampering, and other security breaches that could result in significant inventory losses or operational disruptions.",
      image: ware5,
      imageAlt: "After-hours warehouse patrols",
    },

    /* ---------------- Cargo Protection ---------------- */
    {
      title: "Cargo Protection & Transportation Security",
      accent: "Cargo Protection",
      copy:
        "Cargo theft represents one of the fastest-growing crimes affecting logistics operations, with losses exceeding hundreds of millions annually across Canada. Vision Sécurité provides specialized cargo protection services including secure loading supervision, trailer seal verification, and coordination with transportation security protocols. Our guards understand cargo handling procedures and work closely with logistics coordinators to ensure valuable shipments receive appropriate protection throughout the loading and dispatch process.",
      image: ware6,
      imageAlt: "Cargo and transport protection",
      flip: true,
    },
    {
      title: "High-Value Cargo Security & Chain-of-Custody Procedures",
      accent: "High-Value",
      copy:
        "High-value cargo shipments require enhanced security measures that begin before loading and continue through final delivery coordination. Our security professionals provide discrete cargo protection services that include pre-shipment security assessments, loading dock monitoring, and coordination with transportation providers to ensure secure chain-of-custody procedures. They maintain detailed documentation of all cargo movements and provide immediate response to any security incidents that could compromise valuable shipments.",
      image: ware7,
      imageAlt: "High-value cargo chain-of-custody",
    },
    {
      title: "Transportation Corridor Security & Driver Verification",
      accent: "Corridor Security",
      copy:
        "Transportation corridor security involves protecting goods during the critical transition periods when cargo moves between secure facilities and transportation vehicles. Vision Sécurité guards monitor loading areas, verify driver credentials, and ensure proper security seal application on all outbound shipments. They coordinate with logistics supervisors to maintain security protocols that protect against cargo diversion, theft, and tampering while supporting efficient transportation schedules.",
      image: ware,
      imageAlt: "Transportation corridor monitoring",
      flip: true,
    },

    /* ---------------- Industrial Facilities ---------------- */
    {
      title: "Industrial Facility & Manufacturing Security",
      accent: "Industrial",
      copy:
        "Industrial facilities and manufacturing operations require specialized security approaches that protect both physical assets and production processes from security threats and operational disruptions. Vision Sécurité provides comprehensive industrial security services including equipment protection, raw material security, and finished goods inventory management. Our guards understand industrial environments and maintain security vigilance while supporting continuous production operations.",
      image: ware7,
      imageAlt: "Industrial facility protection",
    },
    {
      title: "Manufacturing Equipment & Asset Protection",
      accent: "Manufacturing",
      copy:
        "Manufacturing facility security encompasses protection of expensive production equipment, raw material inventories, and finished product storage areas that represent significant capital investments. Our security professionals conduct regular equipment inspections, monitor secure storage areas, and coordinate with production supervisors to ensure security measures support rather than hinder manufacturing operations. They understand the value of production equipment and implement specialized protection protocols for high-value machinery and technical installations.",
      image: ware5,
      imageAlt: "Manufacturing security and asset protection",
      flip: true,
    },
    {
      title: "Quality Control & Inventory Management Security",
      accent: "Quality Control",
      copy:
        "Quality control and inventory management security involves protecting against both theft and tampering that could compromise product integrity or result in costly production delays. Vision Sécurité guards monitor quality control areas, secure storage facilities, and finished goods warehouse sections to ensure comprehensive protection throughout the entire production and distribution process.",
      image: ware3,
      imageAlt: "Inventory management and quality assurance security",
    },

    /* ---------------- Supply Chain Security ---------------- */
    {
      title: "Supply Chain Security & Risk Management",
      accent: "Supply Chain",
      copy:
        "Modern supply chains involve complex networks of suppliers, manufacturers, distributors, and retailers that create multiple potential security vulnerabilities requiring coordinated protection strategies. Vision Sécurité provides supply chain security services that identify and address security gaps throughout the entire logistics process. Our security professionals work with logistics coordinators to develop comprehensive risk management protocols that protect against disruptions while maintaining operational efficiency.",
      image: ware6,
      imageAlt: "Supply chain risk management",
      flip: true,
    },
    {
      title: "Vendor & Third-Party Contractor Security",
      accent: "Vendor Security",
      copy:
        "Vendor management and third-party contractor security involves verifying credentials and monitoring activities of external personnel who access secure logistics facilities. Our guards maintain detailed visitor logs, coordinate escort services for contractors, and ensure compliance with facility security protocols by all external personnel. They understand the importance of maintaining security standards while supporting the collaborative relationships essential to modern logistics operations.",
      image: ware1,
      imageAlt: "Contractor and vendor access control",
    },
    {
      title: "Emergency Response & Business Continuity Planning",
      accent: "Emergency Response",
      copy:
        "Emergency response and business continuity planning ensures logistics operations can maintain essential functions during security incidents or other operational disruptions. Vision Sécurité works with facility managers to develop comprehensive emergency response protocols, conduct regular security drills, and maintain communication systems that support rapid coordination with law enforcement and emergency services when required.",
      image: ware7,
      imageAlt: "Emergency response planning for logistics facilities",
      flip: true,
    },

    /* ---------------- Port & Marine Security ---------------- */
    {
      title: "Port & Marine Terminal Security",
      accent: "Port Security",
      copy:
        "The Port of Montreal serves as a critical gateway for international trade, handling millions of dollars in cargo daily and requiring specialized maritime security expertise. Vision Sécurité provides port security services that comply with international maritime security standards while supporting efficient cargo handling operations. Our guards understand port operations and maintain security vigilance appropriate for this critical transportation infrastructure.",
      image: ware3,
      imageAlt: "Port of Montreal security services",
    },
    {
      title: "Container Security & Cargo Inspection",
      accent: "Container Security",
      copy:
        "Container security and cargo inspection involves monitoring container yards, verifying cargo documentation, and coordinating with customs and border security agencies to ensure compliance with international trade security requirements. Our security professionals understand container handling procedures and maintain detailed logs of all container movements throughout port facilities.",
      image: ware4,
      imageAlt: "Cargo inspection and container yard protection",
      flip: true,
    },
    {
      title: "Marine Terminal Access Control & Clearance Management",
      accent: "Marine Access",
      copy:
        "Marine terminal access control requires sophisticated credential verification systems and coordination with multiple maritime agencies to ensure appropriate security clearances for all personnel accessing secure port areas. Vision Sécurité guards manage complex access control systems, coordinate with port authorities, and maintain security protocols that support international maritime security standards.",
      image: ware6,
      imageAlt: "Marine terminal access and credential verification",
    },

    /* ---------------- Technology Integration ---------------- */
    {
      title: "Technology Integration & Advanced Security Systems",
      accent: "Technology Integration",
      copy:
        "Contemporary warehouse and logistics security requires integration between human security professionals and advanced technology systems including RFID tracking, video analytics, and automated inventory management systems. Vision Sécurité coordinates with existing logistics technology infrastructure while providing human oversight and response capabilities that technology alone cannot deliver. Our guards understand modern logistics technology and can operate integrated security systems while maintaining backup procedures during system failures.",
      image: ware3,
      imageAlt: "Technology integration for warehouse security",
      flip: true,
    },
    {
      title: "Inventory Tracking & Loss Prevention Systems",
      accent: "Inventory Tracking",
      copy:
        "Inventory tracking and loss prevention involves coordinating security monitoring with warehouse management systems to identify discrepancies that could indicate theft, damage, or procedural errors. Our security professionals work with inventory managers to investigate discrepancies, document security incidents, and implement corrective measures that reduce future losses while maintaining operational efficiency.",
      image: ware,
      imageAlt: "Loss prevention and real-time tracking",
    },
    {
      title: "Real-Time Monitoring & Reporting Capabilities",
      accent: "Real-Time Monitoring",
      copy:
        "Real-time monitoring and reporting systems provide logistics managers with immediate visibility into security incidents, operational disruptions, and potential threats that could affect supply chain performance. Vision Sécurité maintains communication systems that provide instant notification of security alerts and detailed reporting that supports logistics planning and risk management decisions.",
      image: ware1,
      imageAlt: "Real-time security monitoring and reporting",
      flip: true,
    },

    /* ---------------- Specialized Logistics Security ---------------- */
    {
      title: "Specialized Logistics Security Services",
      accent: "Specialized Logistics",
      copy:
        "Cold storage and temperature-controlled facility security requires understanding of specialized environmental controls and product handling requirements that affect security procedures. Vision Sécurité provides security services for refrigerated warehouses, pharmaceutical distribution centers, and food processing facilities that require specialized security protocols while maintaining strict environmental and regulatory compliance standards.",
      image: ware6,
      imageAlt: "Specialized cold storage and logistics protection",
    },
    {
      title: "Hazardous Materials & Controlled Substance Security",
      accent: "Hazardous Materials",
      copy:
        "Hazardous materials and controlled substance security involves specialized training in handling procedures and regulatory compliance requirements for facilities that store or process dangerous goods. Our security professionals receive appropriate certification and training to provide security services in facilities handling hazardous materials while maintaining compliance with federal and provincial safety regulations.",
      image: ware5,
      imageAlt: "Hazardous material security procedures",
      flip: true,
    },
    {
      title: "E-Commerce Fulfillment Center Security",
      accent: "E-Commerce",
      copy:
        "E-commerce fulfillment center security addresses the unique challenges of high-volume, rapid-turnover operations that process thousands of individual orders daily. Vision Sécurité understands the operational requirements of modern fulfillment centers and provides security services that protect inventory while supporting the rapid processing speeds essential to e-commerce operations.",
      image: ware3,
      imageAlt: "E-commerce warehouse security",
    },

    /* ---------------- Coverage & Performance ---------------- */
    {
      title: "Coverage Areas & Service Deployment",
      accent: "Coverage",
      copy:
        "Vision Sécurité provides warehouse and logistics security services throughout the Greater Montreal Area including major industrial corridors, distribution centers, and manufacturing facilities. Our coverage extends to Port of Montreal operations, rail terminals, and transportation hubs that serve as critical nodes in Québec's logistics infrastructure. We also provide services to logistics facilities throughout Laval, the South Shore, and North Shore regions where significant warehouse and distribution operations support regional and international trade.",
      image: ware,
      imageAlt: "Coverage map for warehouse and logistics protection",
      flip: true,
    },
    {
      title: "Extended Service Areas & Mobile Response Capabilities",
      accent: "Extended Coverage",
      copy:
        "Extended service areas include logistics facilities in Québec City, Eastern Ontario distribution centers in Ottawa-Gatineau, and specialized facilities throughout Québec that require bilingual security services and provincial regulatory compliance expertise. Our mobile response capabilities ensure rapid deployment to multiple logistics facilities and coordination with transportation security requirements.",
      image: ware1,
      imageAlt: "Extended warehouse security service areas",
    },
    {
      title: "Performance Metrics & Service Excellence",
      accent: "Performance Metrics",
      copy:
        "Logistics facilities protected by Vision Sécurité report significant reductions in inventory shrinkage, security incidents, and operational disruptions compared to unprotected facilities. Our average response time to warehouse security incidents is under four minutes, with immediate coordination with logistics supervisors and law enforcement when required. Customer satisfaction surveys consistently rate our security professionals highly for their understanding of logistics operations and minimal disruption to warehouse productivity.",
      image: ware3,
      imageAlt: "Warehouse security performance metrics",
      flip: true,
    },
    {
      title: "Cargo Protection Results & Operational Impact",
      accent: "Cargo Results",
      copy:
        "Cargo protection services demonstrate measurable results in reduced theft incidents, improved chain-of-custody documentation, and enhanced coordination with transportation providers. Our proactive security approach focuses on prevention through visible deterrence, comprehensive monitoring, and immediate response to potential security threats before they escalate into actual losses.",
      image: ware7,
      imageAlt: "Cargo security performance results",
    },
    {
      title: "Getting Started with Warehouse & Logistics Security",
      accent: "Getting Started",
      copy:
        "Every logistics facility presents unique security challenges based on inventory types, operational schedules, facility layout, and transportation requirements. Vision Sécurité begins each warehouse security engagement with comprehensive facility assessments that evaluate current security measures, identify potential vulnerabilities, and develop customized protection protocols. Our assessment process includes risk analysis, operational flow review, technology integration planning, and coordination with existing logistics management systems.",
      image: ware5,
      imageAlt: "Warehouse security assessment and onboarding",
      flip: true,
    },
  ],

  footerCta: {
    title: "Ready to Secure Your Warehouse or Logistics Facility?",
    accent: "secure",
    copy:
      "Contact Vision Sécurité today to schedule a complimentary warehouse security assessment and receive a customized protection plan for your logistics operations.",
    label: "Get Started",
    href: "/contact",
  },
}
,



"events": {
  slug: "events",
  hero: {
    bgImage: luxuryWindsorHero,
    imagePosition: "center",
    bgSize: "cover",
    kicker: "Event Security • Festival & Concert Protection",
    title: "Event Security Services Montreal | Festival & Concert Protection | Vision Sécurité",
    subtitle:
      "Professional event security services in Montreal & Québec. Experienced guards for festivals, concerts, corporate events. Proven track record with major Montreal events.",
    dateISO: "2025-10-13",
    readTimeMin: 7,
    tags: ["Event Security", "Festivals", "Concerts"],
    author: {
      name: "Vision Sécurité Team",
      avatar: "/assets/vision-foundation/avatar.png",
    },
  },

  lead: {
    eyebrow: "Event Security Services in Montreal & Québec",
    title: "Protecting Festivals, Concerts & Special Events",
    accent: "Events",
    copy:
      "Experienced BSP-licensed event guards for festivals, concerts, corporate functions and cultural celebrations—balancing safety, guest experience, and seamless execution.",
  },

  blocks: [
    {
      title: "Professional Event Security Services in Montreal & Québec",
      accent: "Event Security",
      copy:
        "Montreal's vibrant cultural landscape hosts hundreds of major events annually, from world-renowned festivals to intimate corporate gatherings, each requiring specialized security expertise that balances safety with the celebratory atmosphere that makes these occasions memorable. Vision Sécurité has established itself as a trusted partner for event organizers throughout Québec, providing comprehensive security services that protect attendees, performers, and assets while ensuring seamless event execution. Our proven track record includes successful security operations for major Montreal events, demonstrating our capability to handle everything from intimate gatherings to massive festival crowds.",
      image: eventNewBlock1,
      imageAlt: "Event security overview for festivals and concerts",
    },
    {
      title: "Montreal’s Diverse Event Calendar & Tailored Security",
      accent: "Tailored Security",
      copy:
        "Event security in Montreal requires unique expertise that combines crowd psychology, cultural sensitivity, and operational flexibility. The city's diverse event calendar spans electronic music festivals, corporate galas, cultural celebrations, and sporting events, each presenting distinct security challenges and requiring customized protection strategies. Vision Sécurité understands these nuances and provides security solutions that enhance rather than detract from the event experience.",
      image: eventNewBlock2,
      imageAlt: "Montreal event diversity and security planning",
      flip: true,
    },

    /* ---------------- Proven Experience ---------------- */
    {
      title: "Our Proven Event Security Experience",
      accent: "Track Record",
      copy:
        "Vision Sécurité has successfully secured some of Montreal's most prestigious and challenging events, building a reputation for reliability, professionalism, and seamless integration with event operations. Our portfolio includes the Formula 1 weekend festivities on Crescent Street, where we managed complex crowd flows and VIP protection during one of Montreal's busiest weekends. At Igloofest, we provided comprehensive winter festival security, adapting our protocols to extreme weather conditions while maintaining visitor safety and enjoyment throughout the Old Port venue.",
      image: eventNewBlock3,
      imageAlt: "Security at major Montreal events",
    },
    {
      title: "Electronic Festivals, Riverside Venues & National Celebrations",
      accent: "Festivals",
      copy:
        "Our team successfully secured Piknic Électronique events, managing the unique challenges of outdoor electronic music festivals including crowd dynamics, weather variables, and extended operating hours. At Village au Pied du Courant, we coordinated security for this popular riverside venue, balancing public accessibility with necessary protection measures. During Festival MAD Montréal events, we demonstrated our capability to handle diverse cultural programming while maintaining appropriate security presence that supported rather than overshadowed the artistic experience.",
      image: event3,
      imageAlt: "Outdoor and riverside venue security",
      flip: true,
    },
    {
      title: "Unity Field & Saint-Jean-Baptiste with Île-Bizard",
      accent: "Community",
      copy:
        "Unity Field events showcased our expertise in managing electronic music gatherings, where crowd energy and extended hours require specialized security approaches. Our successful coordination of security services for Saint-Jean-Baptiste celebrations with the Municipality of Île-Bizard demonstrated our ability to work effectively with municipal authorities while providing community-focused security services that respect the cultural significance of Québec's national holiday.",
      image: eventNewBlock5,
      imageAlt: "Community and municipal celebration security",
    },

    /* ---------------- Festival & Large-Scale ---------------- */
    {
      title: "Festival & Large-Scale Event Security",
      accent: "Large-Scale",
      copy:
        "Large festivals and outdoor events present unique security challenges that require comprehensive planning, experienced personnel, and adaptive response capabilities. Vision Sécurité provides end-to-end festival security services including pre-event risk assessments, crowd management planning, and coordinated response protocols. Our security professionals understand festival dynamics and work closely with event producers to ensure security measures support rather than hinder the festival experience.",
      image: event5,
      imageAlt: "Large festival crowd security",
      flip: true,
    },
    {
      title: "Crowd Psychology, Flow & Evacuation Readiness",
      accent: "Crowd Management",
      copy:
        "Crowd management at major festivals requires understanding of crowd psychology, flow patterns, and potential pressure points that could create safety hazards. Our guards are trained in crowd behavior recognition, early intervention techniques, and evacuation procedures specific to outdoor venues and temporary structures. They maintain strategic positioning throughout festival grounds while providing discrete monitoring that allows attendees to enjoy events without feeling over-surveilled.",
      image: eventNewBlock7,
      imageAlt: "Crowd flow and behavior monitoring",
    },
    {
      title: "Perimeter Security & Multi-Gate Access Control",
      accent: "Access Control",
      copy:
        "Perimeter security and access control for festivals involves managing multiple entry points, coordinating with ticketing systems, and maintaining security boundaries that prevent unauthorized access while facilitating smooth entry for legitimate attendees. Vision Sécurité coordinates with festival organizers to implement efficient access control procedures that minimize wait times while ensuring proper credential verification and security screening when required.",
      image: eventNewBlock8,
      imageAlt: "Perimeter screening and entry management",
      flip: true,
    },

    /* ---------------- Concert & Entertainment ---------------- */
    {
      title: "Concert & Entertainment Venue Security",
      accent: "Concerts",
      copy:
        "Indoor concert venues and entertainment facilities require specialized security approaches that account for acoustics, lighting conditions, and venue-specific emergency procedures. Vision Sécurité provides comprehensive concert security services including pre-show risk assessments, crowd monitoring during performances, and coordination with venue management and performer security teams. Our guards understand concert environments and maintain security vigilance while allowing audiences to fully engage with performances.",
      image: eventNewBlock9,
      imageAlt: "Indoor concert security operations",
    },
    {
      title: "Artist Protection & Backstage Security",
      accent: "Artist Security",
      copy:
        "Artist protection and backstage security involves coordinating with performer security teams, managing access to restricted areas, and ensuring secure transportation corridors between venues and accommodations. Our security professionals provide discrete protection services that maintain artist privacy while ensuring comprehensive safety coverage during public appearances and private moments.",
      image: eventNewBlock3,
      imageAlt: "Backstage access and artist protection",
      flip: true,
    },
    {
      title: "Venue Coordination & House Security Integration",
      accent: "Venue Integration",
      copy:
        "Venue security coordination includes integration with existing venue security systems, coordination with house security personnel, and adaptation to specific venue layouts and operational procedures. Vision Sécurité works closely with venue management to ensure our security services complement rather than duplicate existing security measures while providing enhanced coverage for special events and high-profile performances.",
      image: eventNewBlock2,
      imageAlt: "Coordination with house security",
    },

    /* ---------------- Corporate & Private ---------------- */
    {
      title: "Corporate Events & Private Functions",
      accent: "Corporate",
      copy:
        "Corporate events and private functions require security approaches that maintain professional atmospheres while providing comprehensive protection for executives, guests, and sensitive business information. Vision Sécurité provides tailored corporate event security services including executive protection, confidential meeting security, and coordination with corporate security policies. Our guards understand business environments and maintain appropriate professional standards while ensuring event security objectives.",
      image: event,
      imageAlt: "Corporate event security and privacy",
      flip: true,
    },
    {
      title: "Executive Protection During Corporate Events",
      accent: "Executive",
      copy:
        "Executive protection during corporate events involves discrete personal security for company leadership, secure transportation coordination, and threat assessment capabilities appropriate for business functions. Our executive protection specialists understand corporate protocols and maintain low profiles while providing comprehensive security coverage for high-profile business leaders during public appearances and private functions.",
      image: event5,
      imageAlt: "Executive escort and transport security",
    },
    {
      title: "Conference & Meeting Security, Document Protection",
      accent: "Meetings",
      copy:
        "Conference and meeting security includes access control for restricted sessions, document security measures, and coordination with audio-visual teams to prevent unauthorized recording of confidential presentations. Vision Sécurité understands corporate confidentiality requirements and provides security services that protect sensitive business information while supporting productive meeting environments.",
      image: eventNewBlock7,
      imageAlt: "Secure conferences and restricted sessions",
      flip: true,
    },

    /* ---------------- VIP & Celebrity ---------------- */
    {
      title: "VIP Protection & Celebrity Security",
      accent: "VIP",
      copy:
        "High-profile events often involve celebrities, dignitaries, and other VIP attendees requiring specialized protection services that balance accessibility with security requirements. Vision Sécurité provides comprehensive VIP protection services including advance security planning, secure transportation coordination, and discrete personal protection during public appearances. Our VIP protection specialists understand the unique challenges of protecting high-profile individuals while maintaining event accessibility for other attendees.",
      image: eventNewBlock8,
      imageAlt: "VIP and celebrity security services",
    },
    {
      title: "Red Carpets, Media Lines & Fan Interaction",
      accent: "Red Carpet",
      copy:
        "Red carpet events and media appearances require security coordination that manages photographer access, fan interactions, and secure movement corridors for VIP attendees. Our guards work closely with event publicists and media coordinators to ensure security measures support rather than hinder promotional objectives while maintaining comprehensive protection for high-profile guests.",
      image: eventNewBlock7,
      imageAlt: "Media line and red carpet security",
      flip: true,
    },
    {
      title: "Backstage & Private Area Security for VIPs",
      accent: "Private Areas",
      copy:
        "Backstage and private area security for VIP attendees involves creating secure zones within event venues where high-profile guests can relax away from public attention while maintaining quick access to main event areas. Vision Sécurité coordinates with event organizers to establish appropriate VIP security protocols that balance privacy requirements with event participation objectives.",
      image: event,
      imageAlt: "VIP private zone protection",
    },

    /* ---------------- Emergency & Crisis ---------------- */
    {
      title: "Emergency Response & Crisis Management",
      accent: "Crisis",
      copy:
        "Event security requires comprehensive emergency response capabilities that can address everything from medical incidents to weather emergencies and security threats. Vision Sécurité maintains detailed emergency response protocols for various event scenarios, coordinates with local emergency services, and provides immediate response capabilities for incidents that could affect attendee safety or event continuity.",
      image: eventNewBlock3,
      imageAlt: "Crisis playbooks and response teams",
      flip: true,
    },
    {
      title: "Medical Emergencies: Coordination & First Response",
      accent: "Medical",
      copy:
        "Medical emergency response coordination involves working with on-site medical teams, maintaining clear evacuation routes, and providing immediate assistance during health emergencies. Our guards receive medical emergency training and can provide first aid response while coordinating with professional medical personnel and emergency services when required.",
      image: event3,
      imageAlt: "Medical coordination at events",
    },
    {
      title: "Weather Procedures for Outdoor Events",
      accent: "Weather",
      copy:
        "Weather emergency procedures for outdoor events include monitoring weather conditions, coordinating with event organizers regarding potential cancellations or delays, and implementing evacuation procedures when severe weather threatens attendee safety. Vision Sécurité maintains communication with weather monitoring services and works with event organizers to make informed decisions regarding weather-related safety measures.",
      image: eventNewBlock2,
      imageAlt: "Severe weather protocols for festivals",
      flip: true,
    },

    /* ---------------- Technology Integration ---------------- */
    {
      title: "Technology Integration & Modern Event Security",
      accent: "Technology",
      copy:
        "Contemporary event security increasingly relies on integration between human security professionals and advanced technology systems including surveillance networks, communication systems, and crowd monitoring tools. Vision Sécurité coordinates with event technology infrastructure while providing human oversight and response capabilities that technology alone cannot deliver. Our guards understand modern event technology and can operate integrated security systems while maintaining personal interaction capabilities essential for effective crowd management.",
      image: event,
      imageAlt: "Integrated comms and surveillance",
    },
    {
      title: "Communications: Radio Nets & Live Coordination",
      accent: "Comms",
      copy:
        "Communication systems coordination involves maintaining constant contact between security personnel, event organizers, and emergency services through sophisticated radio networks and mobile communication systems. Our security teams use coordinated communication protocols that ensure immediate information sharing and rapid response coordination during security incidents or emergency situations.",
      image: eventNewBlock8,
      imageAlt: "Radio and mobile comms for events",
      flip: true,
    },
    {
      title: "Surveillance Integration & Temporary Installs",
      accent: "Surveillance",
      copy:
        "Surveillance integration includes coordination with existing venue surveillance systems and temporary camera installations specific to event requirements. Vision Sécurité works with event technology teams to optimize surveillance coverage while ensuring appropriate privacy protections and coordinated monitoring that supports both security objectives and event operational requirements.",
      image: eventNewBlock5,
      imageAlt: "CCTV overlays for temporary venues",
    },

    /* ---------------- Planning & Consultation ---------------- */
    {
      title: "Event Planning & Security Consultation",
      accent: "Consulting",
      copy:
        "Successful event security begins during the planning phase with comprehensive risk assessments, security protocol development, and coordination with all event stakeholders. Vision Sécurité provides event security consulting services that help organizers identify potential security risks, develop appropriate response protocols, and integrate security measures into overall event planning. Our security consultants work closely with event producers to ensure security considerations are incorporated throughout the planning process.",
      image: eventNewBlock3,
      imageAlt: "Pre-event security consulting",
      flip: true,
    },
    {
      title: "Venue Assessment & Location-Specific Protocols",
      accent: "Venue Planning",
      copy:
        "Venue assessment and security planning involves detailed evaluation of event locations, identification of potential security vulnerabilities, and development of customized security protocols appropriate for specific venues and event types. Our security professionals conduct thorough site inspections and work with venue management to develop comprehensive security plans that address location-specific challenges and opportunities.",
      image: eventNewBlock2,
      imageAlt: "Site walks and venue mapping",
    },
    {
      title: "Stakeholder Coordination & Regulatory Alignment",
      accent: "Stakeholders",
      copy:
        "Stakeholder coordination includes working with event organizers, venue management, local law enforcement, emergency services, and regulatory authorities to ensure comprehensive security coverage that meets all relevant requirements and standards. Vision Sécurité maintains positive relationships with key stakeholders and coordinates security planning that supports all aspects of successful event execution.",
      image: event3,
      imageAlt: "Coordination with police and city services",
      flip: true,
    },

    /* ---------------- Coverage ---------------- */
    {
      title: "Coverage Areas & Service Deployment",
      accent: "Coverage",
      copy:
        "Vision Sécurité provides event security services throughout Québec including major Montreal venues, festival grounds, and temporary event locations throughout the Greater Montreal Area. Our coverage extends to outdoor venues, corporate facilities, and specialized event locations throughout Laval, the South Shore, North Shore, and greater Québec region. We maintain rapid deployment capabilities that enable us to provide security services for events throughout Québec and Eastern Ontario when required.",
      image: event,
      imageAlt: "Québec-wide event coverage",
    },
    {
      title: "Mobile Response & Scalable Resourcing",
      accent: "Mobile",
      copy:
        "Mobile response capabilities ensure our security teams can adapt to changing event requirements and provide additional coverage for unexpected situations or expanding event parameters. Our security coordination centers maintain communication with all deployed personnel and can coordinate additional resources when event situations require enhanced security coverage or specialized response capabilities.",
      image: eventNewBlock8,
      imageAlt: "Mobile teams and surge capacity",
      flip: true,
    },

    /* ---------------- Performance ---------------- */
    {
      title: "Performance Metrics & Service Excellence",
      accent: "Performance",
      copy:
        "Events secured by Vision Sécurité consistently receive positive feedback from organizers, attendees, and venue management regarding our professional security presence and effective incident management. Our average response time to event security incidents is under two minutes, with immediate coordination with event organizers and emergency services when required. Post-event evaluations consistently rate our security teams highly for professionalism, effective crowd management, and minimal disruption to event experiences.",
      image: eventNewBlock7,
      imageAlt: "Event security KPIs and feedback",
    },
    {
      title: "Incident Prevention & Operations Integration",
      accent: "Prevention",
      copy:
        "Event security performance metrics demonstrate measurable results in incident prevention, crowd safety management, and successful coordination with event operations. Our proactive security approach focuses on early identification of potential issues and preventive measures that address security concerns before they escalate into incidents that could affect event safety or success.",
      image: event5,
      imageAlt: "Proactive prevention and integration",
      flip: true,
    },

    /* ---------------- Getting Started ---------------- */
    {
      title: "Getting Started with Event Security Services",
      accent: "Getting Started",
      copy:
        "Every event presents unique security challenges based on venue characteristics, attendance expectations, programming content, and attendee demographics. Vision Sécurité begins each event security engagement with comprehensive event assessments that evaluate specific security requirements, develop customized protection protocols, and coordinate integration with existing event planning and management systems. Our assessment process includes risk analysis, venue evaluation, stakeholder coordination, and development of detailed security operational plans.",
      image: eventNewBlock5,
      imageAlt: "Event assessment and planning",
    },
  ],

  footerCta: {
    title: "Ready to Secure Your Next Event?",
    accent: "secure",
    copy:
      "Get a customized event security plan for festivals, concerts, corporate functions, and VIP engagements. Email: infovision-security.ca",
    label: "Get Started",
    href: "/contact",
  },
}
,

"illegally-occupied-properties": {
  slug: "illegally-occupied-properties",
  hero: {
    bgImage: illegal5,
    imagePosition: "center",
    bgSize: "cover",
    kicker: "Property Protection • Discreet Intervention",
    title: "Illicit Property Occupancy Intervention Montreal & Québec | Vision Sécurité",
    subtitle: "Discreet, legally compliant, and rapid intervention to secure your vacant or at-risk properties across Montreal and Québec.",
    dateISO: "2025-10-13",
    readTimeMin: 6,
    tags: ["Illicit Occupancy", "Property Security", "Intervention Services"],
    author: {
      name: "Vision Sécurité Team",
      avatar: "/assets/vision-foundation/avatar.png",
    },
  },
  lead: {
    eyebrow: "Illicit Property Occupancy Intervention in Montreal & Québec",
    title: "Discreet, Lawful Property Recovery & Security",
    accent: "property",
    copy:
      "Vision Sécurité delivers specialized intervention and security services for vacant or illicitly occupied properties throughout Montreal, Laval, and Québec. Our licensed BSP officers operate within legal frameworks to protect property owners from unauthorized occupation, vandalism, and liability exposure. Every operation emphasizes discretion, professionalism, and community respect while ensuring legal compliance and rapid threat resolution.",
  },
  blocks: [
    {
      title: "Discreet Intervention & Security for Illicitly Occupied Properties in Montreal & Québec",
      accent: "Discreet Intervention",
      copy:
        "Vacant or transitional properties are vulnerable to unauthorized occupation, vandalism, and liability exposure. Property owners in Montreal, Laval, the South Shore, and across Quebec often face the threat of illicit occupants setting up temporary shelters in buildings under renovation, foreclosure, or awaiting sale. Vision Sécurité’s specialized intervention officers provide discreet, legally grounded security and recovery services designed to deter unauthorized occupancy, secure premises, and minimize legal and reputational risk for our clients.",
      image: illegal1,
      imageAlt: "Illicit Occupancy Intervention Officers",
    },
    {
      title: "Rapid Threat Assessment & Response Planning",
      accent: "Rapid Response",
      copy: [
        "When notified of potential unauthorized occupancy, Vision Sécurité conducts an immediate risk assessment that evaluates building accessibility, evidence of habitation, and safety hazards such as open windows, unsecured entry points, or health risks. Within hours of engagement, our intervention team delivers a tailored response plan outlining patrol schedules, engagement protocols, and coordination steps with legal and municipal partners. By establishing clear rules of engagement, we ensure all actions comply with Quebec's civil and criminal regulations regarding trespassing and property rights.",
        "Consistent patrol presence is the cornerstone of deterrence. Our officers execute unpredictable foot and vehicle patrols around the property's perimeter, inspecting all potential entry points—from ground-level doors to rooftop access—without drawing undue attention. A marked security vehicle stationed nearby acts as an effective visual deterrent to would-be occupiers, signaling active property management. By combining casual patrols with documented surveillance reports, we prevent reoccupation attempts and gather evidence of any unauthorized attempts to breach the premises."
      ],
      image: illegal2,
      imageAlt: "Rapid Response Planning",
      flip: true,
    },
    {
      title: "Lawful Occupant Engagement",
      accent: "Engagement",
      copy:
        "In cases where occupiers remain on-site, our intervention officers engage occupants through respectful dialogue, clearly communicating property rights and the necessity of vacating the premises. Trained in de-escalation and conflict resolution, officers explain lawful timelines and escalation steps, offering discreet exit options and temporary solutions if required. Should occupants refuse voluntary departure, Vision Sécurité coordinates with legal counsel and municipal enforcement to initiate formal removal processes under Quebec’s Code civil, ensuring all actions remain within legal bounds and minimizing liability for property owners.",
      image: illegal4,
      imageAlt: "Occupant Engagement Process",
      flip: true,
    },
    {
      title: "Securing Premises & Restoration",
      accent: "Securing Premises",
      copy:
        "Following successful occupant removal, properties require immediate securing to prevent reentry. Vision Sécurité provides temporary boarding solutions, lock replacement, and alarm system installation that reinforce vulnerability points. Our officers collaborate with building maintenance teams to implement durable security measures—such as reinforced doors, window bars, and motion-activated lighting—while maintaining compliance with municipal bylaws. Comprehensive security handover packages, including digital site surveys and vulnerability assessments, guide permanent security upgrades and insurance documentation.",
      image: illegal5,
      imageAlt: "Property Securing and Restoration",
    },
    {
      title: "Documentation & Legal Support",
      accent: "Documentation",
      copy:
        "Evidence preservation is critical for insurance, legal claims, and potential criminal prosecutions. Intervention officers produce detailed incident reports—complete with high-resolution photographs, annotated floor plans, and time-stamped video clips—that document occupancy conditions, security breaches, and officer interactions. These reports support civil claims for property damage, trespassing charges, and insurance recoveries. Vision Sécurité liaises with legal counsel throughout the process, ensuring documentation meets court and insurer evidentiary standards.",
      image: illegal6,
      imageAlt: "Incident Documentation",
      flip: true,
    },
    {
      title: "Regulatory Compliance & Community Relations",
      accent: "Compliance",
      copy:
        "Operating in a legal gray area demands strict compliance with Quebec’s Charter of Human Rights and Freedoms and relevant municipal codes. Our intervention officers receive specialized training in civil procedure, landlord-tenant law exceptions, and trespass statutes, enabling lawful interventions without infringing on occupant rights. Vision Sécurité also engages with local community associations and police services to maintain transparent communication, mitigating negative perceptions and reinforcing civic confidence in property stewardship.",
      image: illegal7,
      imageAlt: "Community and Legal Compliance",
    },
    {
      title: "Getting Started with Intervention Security",
      accent: "Getting Started",
      copy:
        "Every property presents unique challenges based on location, structural vulnerability, and risk factors. Vision Sécurité begins each engagement with a comprehensive site audit that maps entry points, assesses structural conditions, and identifies neighbourhood risk patterns. This audit informs a customized intervention strategy, including patrol frequencies, legal coordination steps, and permanent securing recommendations. Property owners receive a clear action plan and cost estimate before engagement, ensuring transparency and alignment with budgetary requirements.",
      image: photo170Pic,
      imageAlt: "Intervention Security Assessment",
      flip: true,
    },
  ],
  footerCta: {
    title: "Ready to Secure Your Vacant or At-Risk Property?",
    accent: "secure",
    copy:
      "Contact Vision Sécurité today to schedule a rapid on-site assessment and receive a tailored intervention plan for your property’s specific needs.",
    label: "Request an Assessment",
    href: "/contact",
  },
},




"retail-stores": {
  slug: "retail-stores",
  hero: {
    bgImage: retailStoreHero,
    imagePosition: "center",
    bgSize: "cover",
    kicker: "Retail Security • Loss Prevention",
    title: "Retail Security Services Montreal | Loss Prevention & Shoplifting Control | Vision Sécurité",
    subtitle:
      "Professional retail security services in Montreal & Québec. Licensed BSP guards for loss prevention, shoplifting deterrence, and customer safety. 24/7 coverage.",
    dateISO: "2025-10-13",
    readTimeMin: 6,
    tags: ["Retail Security", "Loss Prevention", "Shoplifting Deterrence"],
    author: {
      name: "Vision Sécurité Team",
      avatar: "/assets/vision-foundation/avatar.png",
    },
  },

  lead: {
    eyebrow: "Retail Security Services in Montreal & Québec",
    title: "Professional Retail Security Services in Montreal & Québec",
    accent: "Retail",
    copy:
      "Comprehensive protection for malls, high-street boutiques, big-box and outlet centres—deterring theft while maintaining a welcoming customer experience across Montreal, Laval, South/North Shore, Québec City, and Ottawa–Gatineau.",
  },

  blocks: [
    {
      title: "Professional Retail Security Services in Montreal & Québec",
      accent: "Retail Overview",
      copy:
        "Retail environments—from shopping malls and high-street boutiques to big-box stores and outlet centres—face evolving security challenges that directly impact profitability, customer experience, and brand reputation. With shoplifting, employee theft, and organized retail crime on the rise in Québec, businesses require specialized security solutions that deter criminals while maintaining a welcoming atmosphere. Vision Sécurité delivers comprehensive retail security services across Montreal, Laval, the South Shore, the North Shore, Québec City, and the Ottawa–Gatineau region, helping retailers protect merchandise, employees, and customers without sacrificing hospitality.",
      image: retailBlock1,
      imageAlt: "Retail security overview",
    },
    {
      title: "Loss Prevention & Shoplifting Deterrence",
      accent: "Loss Prevention",
      copy:
        "Effective loss prevention begins with visible yet customer-friendly security presence. Our licensed BSP security guards patrol sales floors, monitor high-risk hotspots—such as fitting rooms, electronics aisles, and high-value displays—and engage in discreet theft deterrence tactics. Guards receive specialized training in recognition of suspicious behaviour, apprehension procedures compliant with Quebec’s civil and criminal codes, and safe recovery of stolen property. By maintaining a proactive posture, Vision Sécurité reduces shrinkage and discourages opportunistic and organized shoplifters alike.",
      image: retailBlock2,
      imageAlt: "Shoplifting deterrence on sales floors",
      flip: true,
    },
    {
      title: "Employee Theft Detection & Internal Risk Management",
      accent: "Internal Risk",
      copy:
        "Employee theft can account for up to 40% of retail losses. Vision Sécurité provides internal theft risk assessments, covert surveillance operations, and inventory audit support to identify and address employee-related losses. Our security professionals collaborate with store management to implement check-out monitoring, back-room access controls, and point-of-sale data analysis. When misconduct is detected, we conduct discreet investigations that respect labour laws and maintain confidentiality, providing detailed incident reports that support disciplinary and legal actions.",
      image: retail3,
      imageAlt: "Internal theft investigations",
    },
    {
      title: "Access Control & Panic Response",
      accent: "Access & Panic",
      copy:
        "Retail stores require flexible access control solutions that manage employee and vendor entry while accommodating customer traffic flow. Vision Sécurité implements badge systems, electronic door controls, and curated access schedules for sensitive areas such as stock rooms, offices, and cash-handling zones. In emergencies—such as robberies or disturbances—our guards activate rapid panic response protocols, secure evacuation routes, and liaise with SPVM or Sûreté du Québec to ensure swift resolution and minimal risk to staff and shoppers.",
      image: retail4,
      imageAlt: "Access control and emergency response",
      flip: true,
    },
    {
      title: "Customer Safety & Crowd Management",
      accent: "Crowd Management",
      copy:
        "High-traffic retail events—like Black Friday sales, product launches, and holiday rushes—present unique crowd management challenges. Vision Sécurité provides specialized crowd control services that include entrance queue management, directional signage enforcement, and temporary barrier deployment. Our guards coordinate with store personnel to open controlled access points and manage lineups, ensuring orderly customer flow, preventing stampedes, and enhancing shopper satisfaction during peak periods.",
      image: retail5,
      imageAlt: "Queue control during peak events",
    },
    {
      title: "Technology-Enhanced Retail Security",
      accent: "Technology",
      copy:
        "Modern retail security combines professional guards with advanced technology tools. Vision Sécurité integrates CCTV monitoring, electronic article surveillance (EAS) antennas, and AI-driven analytics to optimize guard deployment. Real-time incident alerts allow our mobile patrol units to respond immediately to suspicious activity flagged by video analytics. We also support remote monitoring solutions that give regional security managers insights into multiple store locations through centralized dashboards.",
      image: retail6,
      imageAlt: "CCTV, EAS, and analytics integration",
      flip: true,
    },
    {
      title: "High-Value Merchandise & Cash-Handling Protection",
      accent: "High-Value",
      copy:
        "Luxury retailers and jewellery stores require tailored security solutions to protect high-value items. Vision Sécurité guards receive specialized training in high-risk sales interactions, secure display case patrols, and emergency safe-lockdown procedures. During cash-handling operations and float drops, our officers apply dual-control protocols and timed vault access procedures, ensuring robust financial security while supporting seamless customer service.",
      image: retail7,
      imageAlt: "Luxury retail and cash security",
    },
    {
      title: "Retail Chain & Multi-Site Security Programs",
      accent: "Multi-Site",
      copy:
        "Retailers with multiple locations benefit from standardized security programs that maintain consistent protection and reporting across all sites. Vision Sécurité designs multi-site security protocols that include unified post orders, centralized incident documentation, and regular performance audits. Our regional security managers conduct routine store visits, deliver refresher training, and adjust security measures based on individual store layouts, product mixes, and local crime trends.",
      image: retail8,
      imageAlt: "Standardized security across locations",
      flip: true,
    },
    {
      title: "Specialty Retail Environments",
      accent: "Specialty Retail",
      copy:
        "Drugstores, liquor stores, and cannabis dispensaries face additional regulatory and security requirements. Vision Sécurité guards working in these environments receive specialized training in controlled-substance regulations, age-verification assistance, and compliance monitoring. We help dispensaries and pharmacies implement secure queuing systems, reinforced perimeter controls, and safe-room protocols for staff during high-risk deliveries or pickups.",
      image: retailBlock9,
      imageAlt: "Specialty retail compliance and security",
    },
    {
      title: "Emergency Response & Incident Reporting",
      accent: "Incident Response",
      copy:
        "Retail incidents—from shoplifting attempts to medical emergencies—require immediate, coordinated response. Vision Sécurité guards follow detailed emergency action plans that include first-aid response, defibrillator use, and liaison with medical services. Post-incident, our officers compile thorough reports with photographic evidence, witness statements, and time-stamped logs that support insurance claims, legal proceedings, and management reviews.",
      image: retail4,
      imageAlt: "Rapid response and reporting",
      flip: true,
    },
    {
      title: "Why Retailers Choose Vision Sécurité",
      accent: "Why Us",
      copy:
        "Licensed BSP professionals, customer-centric service, and Quebec-specific expertise set Vision Sécurité apart. Our guards balance vigilant security oversight with friendly customer interaction, enhancing the shopping experience while deterring loss. Continuous training in retail crime prevention, Quebec privacy legislation, and emergency procedures ensures our teams deliver reliable protection that aligns with your brand values and operational goals.",
      image: retail3,
      imageAlt: "Trusted retail security partner",
    },
    {
      title: "Coverage Areas & Service Deployment",
      accent: "Coverage",
      copy:
        "Vision Sécurité provides retail security services throughout Montreal’s primary retail districts—Downtown, Plateau, West Island—and suburban centres in Laval, Longueuil, Brossard, and Terrebonne. We deploy teams to outlet malls, lifestyle centres, high-foot-traffic urban storefronts, and corporate headquarters. Extended coverage reaches Quebec City retailers and the Ottawa–Gatineau area, offering bilingual service and local regulatory compliance support across provincial lines.",
      image: retail2,
      imageAlt: "Retail coverage across Quebec",
      flip: true,
    },
    {
      title: "Getting Started with Retail Security",
      accent: "Getting Started",
      copy:
        "Every retail environment presents unique security and operational requirements. Vision Sécurité begins each engagement with a comprehensive security assessment that includes site walkthroughs, vulnerability analysis, and loss prevention gap evaluations. We collaborate with store management to develop customized security plans detailing guard schedules, technology integrations, and performance metrics. Implementation typically completes within two weeks, with expedited deployments available for urgent risk scenarios.",
      image: retail7,
      imageAlt: "Retail security assessment and rollout",
    },
  ],

  footerCta: {
    title: "Ready to Reduce Shrink and Elevate Store Safety?",
    accent: "reduce",
    copy:
      "Contact Vision Sécurité today to schedule a retail loss-prevention assessment and receive a customized protection plan for your stores.",
    label: "Get Started",
    href: "/contact",
  },
}
,




     "hotels": {
  slug: "hotels",
  hero: {
    bgImage: hotelLobby,
    imagePosition: "center",
    bgSize: "cover",
    kicker: "Hotel Security • Guest Safety & Concierge Support",
    title: "Hotel Security Services Montreal | Guest Safety & Concierge Protection | Vision Sécurité",
    subtitle:
      "Professional hotel security services in Montreal & Québec. Licensed BSP guards for guest safety, concierge support, and event security. 24/7 discreet presence.",
    dateISO: "2025-10-13",
    readTimeMin: 6,
    tags: ["Hotel Security", "Hospitality", "Guest Safety"],
    author: {
      name: "Vision Sécurité Team",
      avatar: "/assets/vision-foundation/avatar.png",
    },
  },

  lead: {
    eyebrow: "Hotel Security Services in Montreal & Québec",
    title: "Professional Hotel Security Services in Montreal & Québec",
    accent: "Hotel",
    copy:
      "Discreet, guest-centric protection for boutique properties and convention hotels across Montreal, Québec City, and Ottawa–Gatineau — blending hospitality with rigorous safety.",
  },

  blocks: [
    {
      title: "Professional Hotel Security Services in Montreal & Québec",
      accent: "Hospitality Security",
      copy:
        "Hotels in Montreal and across Québec require a security partner that understands both hospitality and protection. Vision Sécurité provides licensed BSP security professionals who blend discreet guest-centric service with rigorous safety protocols. From boutique properties in Plateau-Mont-Royal to large downtown convention hotels, our hotel security solutions safeguard guests, staff, and assets without compromising the warm welcome that defines a premier hospitality experience.",
      image: hotel1,
      imageAlt: "Hotel lobby with discreet security presence",
    },
    {
      title: "Tourism Demands & Seamless Guest Experience",
      accent: "Tourism",
      copy:
        "Montreal’s dynamic tourism sector—highlighted by events like Grand Prix weekend, jazz festivals, and international conferences—places unique demands on hotel security. Vision Sécurité’s teams manage lobby presence, access control, and emergency response with seamless coordination, ensuring guests feel secure yet unencumbered by heavy-handed security measures.",
      image: hotel2,
      imageAlt: "Major event periods and hotel security coordination",
      flip: true,
    },

    /* ---------------- Concierge & Lobby ---------------- */
    {
      title: "Concierge & Lobby Security",
      accent: "Concierge",
      copy:
        "Our security officers integrate with front-desk operations, assisting with guest screening, luggage monitoring, and VIP escort services. They maintain a visible yet unobtrusive posture in lobby and common areas, ready to intervene at the first sign of suspicious behavior. By collaborating closely with concierge staff, our officers support guest services—handling lost-and-found protocols, guiding confused visitors, and discreetly managing loiterers or unwelcome individuals.",
      image: hotel3,
      imageAlt: "Concierge desk with integrated security",
    },

    /* ---------------- Guest Floors ---------------- */
    {
      title: "Guest Room & Floor Patrols",
      accent: "Floor Patrols",
      copy:
        "Routine floor patrols reinforce guest confidence and deter unauthorized intrusions. Vision Sécurité officers conduct randomized checks of corridors, stairwells, and service areas, verifying that only authorized individuals access guest floors. Our patrols include monitoring emergency exits for tampering, checking electronic door-lock function, and liaising with engineering to address safety hazards promptly.",
      image: hotel4,
      imageAlt: "Guest floor corridor patrol",
      flip: true,
    },

    /* ---------------- Events ---------------- */
    {
      title: "Event & Conference Security",
      accent: "Events",
      copy:
        "Hotel-based events—from business conferences to gala dinners—require specialized crowd management and access protocols. Vision Sécurité tailors security plans for each event, managing registration areas, VIP lounges, and back-of-house corridors. Our officers coordinate with event planners on credential verification, emergency evacuation paths, and rapid response teams for medical or security incidents, ensuring flawless event execution in compliance with fire and safety regulations.",
      image: hotel5,
      imageAlt: "Conference registration with security oversight",
    },

    /* ---------------- Parking ---------------- */
    {
      title: "Valet & Parking Security",
      accent: "Parking",
      copy:
        "Hotel parking facilities often present elevated risk for vehicle theft, vandalism, or perimeter breaches. Our officers patrol parking levels, enforce visitor-only access, and monitor CCTV feeds in real time. They coordinate with valet staff to verify driver credentials and ensure proper vehicle handling, reducing liability and enhancing guest trust in hotel services.",
      image: hotel6,
      imageAlt: "Valet lane and garage patrol",
      flip: true,
    },

    /* ---------------- Emergencies ---------------- */
    {
      title: "Emergency Response & Crisis Management",
      accent: "Emergency",
      copy:
        "Vision Sécurité’s hotel security officers receive advanced training in first-aid, fire safety, and emergency evacuation procedures. In the event of a medical emergency, fire alarm activation, or security threat, our officers execute pre-planned response protocols—guiding guests to safety, liaising with SPVM or fire services, and preserving incident scenes for investigation. Post-incident, we provide detailed reports to hotel management to support insurance claims and regulatory reviews.",
      image: hotel7,
      imageAlt: "Emergency response coordination in hotels",
    },

    /* ---------------- Tech ---------------- */
    {
      title: "Technology-Enhanced Hospitality Security",
      accent: "Technology",
      copy:
        "Our hotel security program integrates with guest management systems, electronic door-lock platforms, and CCTV networks. Vision Sécurité officers use mobile patrol devices that log security checks, generate real-time incident alerts, and capture multimedia evidence. This technology-enabled approach ensures comprehensive coverage while maintaining the personalized service expected in hospitality environments.",
      image: hotel1,
      imageAlt: "CCTV and door-lock system integration",
      flip: true,
    },

    /* ---------------- Why Us ---------------- */
    {
      title: "Why Vision Sécurité for Hotels",
      accent: "Why Us",
      copy:
        "Licensed BSP professionals, hospitality etiquette training, and local expertise set Vision Sécurité apart. Our officers understand Quebec’s language requirements, cultural nuances, and regulatory landscape—ensuring seamless, bilingual guest interactions. Continuous scenario-based training prepares our teams for unique hotel challenges, from VIP protection to large-scale event security.",
      image: hotel2,
      imageAlt: "Bilingual, hospitality-trained officers",
    },

    /* ---------------- Coverage ---------------- */
    {
      title: "Coverage Areas & Deployment",
      accent: "Coverage",
      copy:
        "Vision Sécurité serves hotels throughout Montreal’s central districts, the West Island, Laval, and key resort areas on the South and North Shores. We also deploy to Quebec City’s hotel corridor and Ottawa-Gatineau hospitality venues. Our flexible staffing model supports single-property contracts, multi-hotel portfolios, and on-demand event bolstering for peak tourism seasons.",
      image: hotel3,
      imageAlt: "Coverage across Quebec and Ottawa–Gatineau",
      flip: true,
    },

    /* ---------------- Getting Started ---------------- */
    {
      title: "Getting Started with Hotel Security",
      accent: "Getting Started",
      copy:
        "Each hotel engagement begins with a complimentary security assessment—evaluating lobby layout, event spaces, guest floor design, and parking facilities. Vision Sécurité works with hotel leadership to develop customized security plans that align with brand standards and operational workflows. Mobilization typically completes within 5 business days, with expedited options for urgent operational needs.",
      image: hotel4,
      imageAlt: "Hotel security assessment and mobilization",
    },
  ],

  footerCta: {
    title: "Ready to Elevate Guest Safety and Experience?",
    accent: "elevate",
    copy:
      "Contact Vision Sécurité for a tailored hotel security proposal that blends hospitality excellence with rigorous protection—24/7 coverage available.",
    label: "Request a Proposal",
    href: "/contact",
  },
}

};

export default whoWeServeData;






